/* Juwelier Benjamin – Trauring-Konfigurator (Version 2).
   Modelle, Bilder und Herstellerpreise: CILOR (jb-konfigurator-modelle.json). Farbe je Modell aus dem Bild ermittelt.
   Funktionsumfang laut 01-checkliste-funktionen-wettbewerb.md.
   Regeln: keine Inline-Handler, Nutzereingaben nur per textContent, Messereignisse ohne Personendaten. */
(function () {
  'use strict';

  var LEG = ['Gold 333', 'Gold 585', 'Gold 750'];
  var LEG_HINT = ['33,3 % Gold', '58,5 % Gold', '75 % Gold'];
  var STEIN = ['Ohne Steinbesatz', 'Zirkonia', 'Brillant'];
  var STEIN_HINT = ['klassisch, ohne Steine', 'funkelnder Schmuckstein', 'echter Diamant'];
  var FARBWUNSCH = [['bild', 'Wie abgebildet'], ['g', 'Gelbgold'], ['w', 'Weißgold'], ['r', 'Rotgold'], ['bi', 'Zweifarbig']];
  var OBERFL = [['bild', 'Wie abgebildet'], ['poliert', 'Poliert (glänzend)'], ['matt', 'Matt'], ['gemischt', 'Poliert und matt']];
  var BREITE = [['bild', 'Wie abgebildet'], ['schmaler', 'Etwas schmaler'], ['breiter', 'Etwas breiter']];
  var ANLIEGEN = ['Beratungstermin im Laden', 'Preis und Verfügbarkeit', 'Modell reservieren'];
  var SCHRIFTEN = [['Schreibschrift', 'jb-gr-0'], ['Klassisch', 'jb-gr-1'], ['Modern', 'jb-gr-2']];
  var SYMBOLE = ['♥', '∞', '&', '✦', '⚭'];
  var FARBNAME = { g: 'Gelbgold', w: 'Weißgold', r: 'Rotgold' };
  var MAX_GRAVUR = 30;
  var SCHRITTE = ['Modell', 'Edelmetall', 'Maße', 'Gravur', 'Anfrage'];
  var HILFE = {
    1: 'Alle Modelle stammen aus der Trauringmanufaktur CILOR. Filtern Sie nach Kollektion oder Farbe oder suchen Sie eine Modellnummer. Die Farbe ist aus dem Herstellerfoto ermittelt.',
    2: 'Die Zahl der Legierung nennt den Goldanteil in Tausendsteln: 333 = 33,3 %, 585 = 58,5 %, 750 = 75 % Gold. Zirkonia ist ein synthetischer Schmuckstein, ein Brillant ist ein Diamant im Brillantschliff. Form, Breite und Steinposition entsprechen dem abgebildeten Modell. Abweichende Wünsche geben Sie einfach mit an, wir klären sie mit dem Hersteller.',
    3: 'Die Ringgröße entspricht dem Innenumfang in Millimetern, daneben steht der Durchmesser. Sie kennen Ihre Größe nicht? Dann lassen Sie das Feld offen, wir messen gern bei uns im Laden. Mit „Größe ermitteln“ rechnen Sie einen gemessenen Umfang um.',
    4: 'Bis zu 30 Zeichen je Ring. Typisch sind Name und Datum. Die Vorschau zeigt die Wirkung der Schrift, die genaue Gravur stimmen wir persönlich mit Ihnen ab.',
    5: 'Ihre Auswahl kommt vollständig bei uns an, inklusive Link zu genau dieser Konfiguration. Wir melden uns persönlich bei Ihnen.'
  };
  var GROESSEN = [];
  for (var gg = 460; gg <= 740; gg += 5) GROESSEN.push(gg / 10);
  var FAV_MAX = 30, VGL_MAX = 3;
  /* Ring-Finder: nur Felder, die es in den Daten wirklich gibt (Preis, Farbe laut Foto, Legierung, Steinbesatz). */
  var FINDER_BUDGET = [[750, 'bis 750 €'], [1000, 'bis 1.000 €'], [1250, 'bis 1.250 €'], [1500, 'bis 1.500 €'], [0, 'Egal']];
  var FINDER_FARBE = [['g', 'Gelbgold'], ['w', 'Weißgold'], ['r', 'Rotgold'], ['bi', 'Zweifarbig'], ['', 'Egal']];
  var FINDER_STEIN = [[0, 'Ohne Steine'], [1, 'Mit Zirkonia'], [2, 'Mit Brillant'], [-1, 'Egal']];
  var FINDER_LEG = [[0, 'Gold 333'], [1, 'Gold 585'], [2, 'Gold 750'], [-1, 'Weiß ich nicht']];
  var NS = 'http://www.w3.org/2000/svg';
  var ringZaehler = 0;

  /* ---------- Helfer ---------- */
  function el(tag, attrs, kinder) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'text') n.textContent = v;
      else if (k === 'class') n.className = v;
      else n.setAttribute(k, v === true ? '' : v);
    });
    (kinder || []).forEach(function (c) { if (c !== null && c !== undefined && c !== false) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function svgEl(tag, attrs, kinder) {
    var n = document.createElementNS(NS, tag);
    Object.keys(attrs || {}).forEach(function (k) { if (k === 'text') n.textContent = attrs[k]; else n.setAttribute(k, attrs[k]); });
    (kinder || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function herzIcon() {
    return svgEl('svg', { viewBox: '0 0 24 24', width: '22', height: '22', 'aria-hidden': 'true', focusable: 'false', class: 'jb-konf__icon' },
      [svgEl('path', { d: 'M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.1 3.6 4.5 7.1 4.5c2 0 3.5 1.1 4.9 2.9 1.4-1.8 2.9-2.9 4.9-2.9 3.5 0 5.6 3.6 4.4 6.8-1.8 4.6-9.3 9.2-9.3 9.2z' })]);
  }
  function vglIcon() {
    return svgEl('svg', { viewBox: '0 0 24 24', width: '22', height: '22', 'aria-hidden': 'true', focusable: 'false', class: 'jb-konf__icon' },
      [svgEl('path', { d: 'M7 7h12M15 3l4 4-4 4M17 17H5M9 13l-4 4 4 4' })]);
  }
  function knopf(text, cls, fn, attrs) {
    var b = el('button', Object.assign({ type: 'button', class: cls || 'jb-konf__btn', text: text }, attrs || {}));
    if (fn) b.addEventListener('click', fn);
    return b;
  }
  function euro(n) { return n.toLocaleString('de-DE') + ' €'; }
  function groesseText(g) { return String(g).replace('.', ',') + ' (Ø ' + (g / Math.PI).toFixed(2).replace('.', ',') + ' mm)'; }
  function track(event, daten) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: event, jb_seite: 'trauring_konfigurator' };
    Object.keys(daten || {}).forEach(function (k) { o[k] = daten[k]; });
    window.dataLayer.push(o);
  }
  function b64(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function unb64(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return decodeURIComponent(escape(atob(s))); }
  /* Zeichen zählen wie Kunden sie sehen (Emoji = 1). Einzelne Ersatzzeichen werden zu U+FFFD, ohne toWellFormed (fehlt vor Safari 16.4). */
  function zeichen(s) { return Array.from(String(s || '')).map(function (c) { return c.length === 1 && c >= '\uD800' && c <= '\uDFFF' ? '�' : c; }); }
  function gravurText(s) { return zeichen(s).slice(0, MAX_GRAVUR).join(''); }
  /* Theme-Einstellung „Gravurarten“: Name | Erklärung | Aufpreis-Text, je Zeile. Nur Text, gekürzt, höchstens 6 Zeilen. */
  function gravurartenLesen(t) {
    return String(t || '').split(/\r?\n/).map(function (z) {
      return z.split('|').map(function (x) { return x.replace(/[\u0000-\u001f\u007f]/g, '').trim(); });
    }).filter(function (p) { return p[0]; }).slice(0, 6).map(function (p) {
      return { name: p[0].slice(0, 40), info: (p[1] || '').slice(0, 120), preis: (p[2] || '').slice(0, 60) };
    });
  }
  function speicherLesen(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function speicherSchreiben(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }

  /* Aktion (z. B. Oktober-Special): Code, Prozent je Ring, letzter Gültigkeitstag. Läuft nur mit eingeschalteten Preisen. */
  function aktionLesen(root) {
    var code = String(root.getAttribute('data-promo-code') || '').trim().toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 30);
    var prozent = parseInt(root.getAttribute('data-promo-percent'), 10) || 0;
    var bis = String(root.getAttribute('data-promo-until') || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    var ende = bis ? berlinTagesende(Number(bis[1]), Number(bis[2]), Number(bis[3])) : null;
    return {
      an: root.getAttribute('data-promo') === 'true' && !!code && prozent > 0 && prozent < 100 && !!ende && !isNaN(ende),
      code: code, prozent: prozent, ende: ende,
      titel: String(root.getAttribute('data-promo-title') || '').trim().slice(0, 60) || 'Aktion',
      bedingungen: String(root.getAttribute('data-promo-terms') || '').trim().slice(0, 300)
    };
  }
  /* Letzter Gültigkeitstag endet um 23:59:59 Uhr deutscher Zeit, egal in welcher Zeitzone der Besucher ist */
  function berlinTagesende(j, m, t) {
    var utc = Date.UTC(j, m - 1, t, 23, 59, 59), versatz = 60;
    try {
      var teil = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', timeZoneName: 'shortOffset' }).formatToParts(new Date(utc))
        .filter(function (x) { return x.type === 'timeZoneName'; })[0];
      var g = teil && teil.value.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
      if (g) versatz = (g[1] === '-' ? -1 : 1) * (Number(g[2]) * 60 + Number(g[3] || 0));
      else if (teil && teil.value === 'GMT') versatz = 0;
    } catch (e) { /* ältere Browser: MEZ */ }
    return new Date(utc - versatz * 60000);
  }
  function datumText(d) { return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' }); }

  function start(root) {
    var cfg = {
      quelle: root.getAttribute('data-src'),
      bildModus: root.getAttribute('data-img-mode') || 'cilor',
      bildBasis: root.getAttribute('data-img-base') || '',
      preise: root.getAttribute('data-prices') === 'true',
      aufschlag: parseFloat(root.getAttribute('data-price-markup')) || 0,
      preisHinweis: root.getAttribute('data-price-note') || '',
      proSeite: parseInt(root.getAttribute('data-per-page'), 10) || 24,
      telefonText: root.getAttribute('data-phone-text') || '',
      telefonLink: String(root.getAttribute('data-phone-link') || '').replace(/[^+\d]/g, ''),
      paar: root.getAttribute('data-price-pair') === 'true',
      gravurarten: gravurartenLesen(root.getAttribute('data-engraving-types')),
      lieferzeit: String(root.getAttribute('data-delivery-note') || '').trim().slice(0, 200),
      aktion: aktionLesen(root)
    };
    var app = root.querySelector('[data-jb-konf-app]');
    var formWrap = root.querySelector('[data-jb-konf-form-wrap]');
    var formular = root.querySelector('form.jb-konf__form');
    var erfolg = root.querySelector('[data-jb-konf-erfolg]');
    var navEl = root.querySelector('[data-jb-konf-nav]');
    var erfolgDa = !!erfolg;
    var formParkplatz = el('div', { hidden: true });
    root.appendChild(formParkplatz);

    var D = null;
    var GRUND = { legierung: 1, stein: 0, g1: 0, g2: 0, gr1: '', gr2: '', f1: 0, f2: 0, gravurTab: 1,
      farbwunsch: 'bild', oberflaeche: 'bild', breite: 'bild', vorsteck: false, anliegen: 0, gravurArt: 0 };
    var Z = Object.assign({ modell: null, schritt: 1 }, GRUND);
    var edelmetallBestaetigt = false, steinBestaetigt = false;
    function auswahlBestaetigen(art) {
      if (Z.schritt !== 2) return;
      if (art === 'legierung') edelmetallBestaetigt = true;
      if (art === 'stein') steinBestaetigt = true;
      if (edelmetallBestaetigt && steinBestaetigt) schritt(3);
    }
    function fLeer() { return { kollektion: -1, farbe: '', suche: '', sort: '', maxPreis: 0, sichtbar: cfg.proSeite, liste: '', finder: null }; }
    var F = fLeer();
    /* Paar-Modus und Vergleich: nur Modellnummern, keine Personendaten. */
    var favs = [], partner = [], vergleich = [], merkSpeicherAus = false;
    var rasterNeu = null, merkNeu = null, vglNeu = null;
    /* Reiner Ansichts-Zustand (nicht im Code/Link): offene Klappen bleiben beim Neuzeichnen offen. */
    var filterOffen = false, mehrOffen = false, sonderOffen = {};
    var verlauf = [];
    var gemeldet = {};
    var suchTimer, tippTimer;
    var meldung = el('p', { class: 'jb-konf__hinweis', role: 'status', hidden: true });
    app.parentNode.insertBefore(meldung, app);
    function hinweis(text, hervor) { meldung.textContent = text; meldung.hidden = !text; meldung.classList.toggle('jb-konf__meldung--hervor', !!hervor); }
    var speicherMeldung = el('p', { class: 'jb-konf__hinweis', role: 'status', hidden: true });
    app.parentNode.insertBefore(speicherMeldung, app);
    var aktionEl = el('div', { class: 'jb-konf__aktion', hidden: true });
    app.parentNode.insertBefore(aktionEl, app);
    function speicherWarnung(text) {
      if (speicherMeldung.textContent.indexOf(text) >= 0) return;
      speicherMeldung.textContent = (speicherMeldung.textContent ? speicherMeldung.textContent + ' ' : '') + text;
      speicherMeldung.hidden = false;
    }

    /* ---------- Bilder ---------- */
    function bildUrl(m, breite) {
      if (cfg.bildModus === 'shopify') return cfg.bildBasis + m.f + '?width=' + breite;
      if (breite <= 400) return cfg.bildBasis + m.b.replace(/(\.[a-z]+)$/i, '-400x400$1');
      return cfg.bildBasis + m.b;
    }
    function bild(m, breite, alt, lazy) {
      var img = el('img', { src: bildUrl(m, breite), alt: alt, width: breite, height: breite, loading: lazy ? 'lazy' : null, decoding: 'async' });
      if (cfg.bildModus === 'shopify' && breite === 400) {
        img.setAttribute('srcset', [180, 280, 400, 560].map(function (w) { return bildUrl(m, w) + ' ' + w + 'w'; }).join(', '));
        img.setAttribute('sizes', '(max-width: 760px) calc((100vw - 42px) / 2), (max-width: 990px) calc((100vw - 64px) / 3), (max-width: 1212px) calc((100vw - 80px) / 4), 283px');
      }
      if (cfg.bildModus !== 'shopify') img.addEventListener('error', function onErr() { img.removeEventListener('error', onErr); img.src = cfg.bildBasis + m.b; });
      return img;
    }

    /* ---------- Daten-Helfer ---------- */
    /* Verkaufspreis je Ring = Cilor-Preis + Aufschlag laut Theme-Einstellung, auf volle Euro gerundet */
    function preis(m, l, s) { var r = m && m.p ? m.p[l * 3 + s] : 0; return r ? Math.round(r * (1 + cfg.aufschlag / 100)) : 0; }
    /* Aktion: Preis mit Code je Ring, auf volle Euro gerundet. Nur solange die Aktion läuft und der Code eingelöst ist. */
    function aktionLaeuft() { return cfg.preise && cfg.aktion.an && new Date() <= cfg.aktion.ende; }
    var codeEingeloest = false;
    function codeAn() { return codeEingeloest && aktionLaeuft(); }
    function mitCode(p) { return p ? Math.round(p * (1 - cfg.aktion.prozent / 100)) : 0; }
    /* Preis, der in Listen, Filtern und Sortierung zählt: mit eingelöstem Code der Aktionspreis */
    function ep(p) { return codeAn() ? mitCode(p) : p; }
    function codeSpeichern() { try { sessionStorage.setItem('jb_konf_code', codeEingeloest ? cfg.aktion.code : ''); } catch (e) { /* privat */ } }
    function codeEinloesen(eingabe, quelle) {
      var c = String(eingabe || '').trim().toUpperCase().replace(/\s+/g, '');
      if (!aktionLaeuft() || c !== cfg.aktion.code) return false;
      var neu = !codeEingeloest;
      codeEingeloest = true; codeSpeichern();
      if (neu) track('jb_konfigurator_aktion', { jb_aktion: 'code_eingeloest', jb_quelle: quelle || 'knopf' });
      return true;
    }
    function verfuegbar(m, l, s) { return !m || !m.p || m.p[l * 3 + s] > 0; }
    var abPreise = new WeakMap();
    function abPreis(m) {
      if (!abPreise.has(m)) {
        var x = (m.p || []).map(function (_, i) { return preis(m, Math.floor(i / 3), i % 3); }).filter(function (v) { return v > 0; });
        abPreise.set(m, x.length ? Math.min.apply(null, x) : 0);
      }
      return abPreise.get(m);
    }
    function farbeText(c) {
      if (!c) return 'laut Abbildung';
      if (c.length === 1) return FARBNAME[c];
      return (c.length === 2 ? 'Zweifarbig: ' : 'Dreifarbig: ') + c.split('').map(function (x) { return FARBNAME[x].replace('gold', ''); }).join('/');
    }
    function kollName(m) { return D.kollektionen[m.k]; }
    function wahlText(liste, wert) { return liste.filter(function (x) { return x[0] === wert; })[0][1]; }
    function passendeVariante() {
      var m = Z.modell;
      if (verfuegbar(m, Z.legierung, Z.stein)) return;
      for (var l = 0; l < 3; l++) for (var s = 0; s < 3; s++) if (verfuegbar(m, l, s)) { Z.legierung = l; Z.stein = s; return; }
    }

    /* ---------- Code / Link (Speichern, Teilen, Laden) ---------- */
    function nrNorm(s) { return String(s || '').replace(/[\s_]+/g, '').toLowerCase(); }
    function modellZuNr(nr) { var n = nrNorm(nr); return D.modelle.filter(function (x) { return nrNorm(x.m) === n; })[0]; }
    function codeBauen(ohneGravur) {
      if (!Z.modell) return '';
      var opt = [Z.legierung, Z.stein, Z.f1, Z.f2, FARBWUNSCH.map(function (x) { return x[0]; }).indexOf(Z.farbwunsch),
        OBERFL.map(function (x) { return x[0]; }).indexOf(Z.oberflaeche), BREITE.map(function (x) { return x[0]; }).indexOf(Z.breite), Z.vorsteck ? 1 : 0, Z.anliegen, Z.gravurTab - 1].join('') +
        (Z.gravurArt ? String(Z.gravurArt) : '');
      return [Z.modell.m.replace(/\s+/g, '_'), opt, Math.round(Z.g1 * 10) || 0, Math.round(Z.g2 * 10) || 0,
        !ohneGravur && Z.gr1 ? b64(Z.gr1) : '', !ohneGravur && Z.gr2 ? b64(Z.gr2) : ''].join('.');
    }
    function codeLaden(code) {
      try {
        code = String(code || '').trim();
        if (code.length > 4000) return false;
        var hash = (code.match(/#.*$/) || [''])[0];
        var u = code.match(/[?&]konf=([^&#]+)/); if (u) code = decodeURIComponent(u[1]);
        else code = code.split('#')[0];
        var t = code.split(/[.~]/); if (t.length < 4 || t.length > 6) return false;
        var m = modellZuNr(t[0]);
        if (!m) return false;
        if (!/^[0-2]{4}[0-4][0-3][0-2][01]([0-2]{2}[0-6]?)?$/.test(t[1]) || !/^\d{1,3}$/.test(t[2]) || !/^\d{1,3}$/.test(t[3])) return false;
        var o = t[1].split('').map(Number), g1 = Number(t[2]) / 10, g2 = Number(t[3]) / 10;
        if ((g1 && GROESSEN.indexOf(g1) < 0) || (g2 && GROESSEN.indexOf(g2) < 0)) return false;
        var gr = [t[4] || '', t[5] || ''];
        if (hash.indexOf('#gravur=') === 0) {
          var h = hash.match(/^#gravur=([A-Za-z0-9_-]*)\.([A-Za-z0-9_-]*)$/); if (!h) return false;
          gr = [h[1], h[2]];
        }
        if (gr.some(function (v) { return !/^[A-Za-z0-9_-]*$/.test(v); })) return false;
        // Erst vollständig prüfen/decodieren, dann den aktuellen Stand ersetzen.
        var neu = Object.assign({}, Z, { modell: m, legierung: o[0], stein: o[1], f1: o[2], f2: o[3],
          farbwunsch: FARBWUNSCH[o[4]][0], oberflaeche: OBERFL[o[5]][0], breite: BREITE[o[6]][0], vorsteck: o[7] === 1,
          anliegen: o[8] || 0, gravurTab: (o[9] || 0) + 1, gravurArt: o[10] && o[10] <= cfg.gravurarten.length ? o[10] : 0, g1: g1, g2: g2,
          gr1: gravurText(unb64(gr[0])), gr2: gravurText(unb64(gr[1])) });
        Z = neu;
        passendeVariante();
        return true;
      } catch (e) { return false; }
    }
    /* Gravurtexte (oft Namen) stehen nur in geteilten/gespeicherten Links und in der Anfrage,
       nie in der Adresszeile: Mess-Tags lesen die Seitenadresse mit. */
    function linkBauen(ohneGravur) {
      var u = new URL(window.location.href);
      ['modell', 'konf', 'contact_posted', 'preise', 'testdaten', 'favs', 'code'].forEach(function (k) { u.searchParams.delete(k); });
      u.hash = '';
      if (Z.modell) u.searchParams.set('konf', codeBauen(true));
      /* Fragmente werden nicht im HTTP-Aufruf gesendet, bleiben aber für Seiten-Skripte lesbar. */
      if (Z.modell && !ohneGravur && (Z.gr1 || Z.gr2)) u.hash = 'gravur=' + (Z.gr1 ? b64(Z.gr1) : '') + '.' + (Z.gr2 ? b64(Z.gr2) : '');
      return u.toString().replace(/%7E/gi, '~');
    }
    function gravurAusHash(h) {
      var g = String(h || '').match(/^#gravur=([A-Za-z0-9_-]*)\.([A-Za-z0-9_-]*)$/);
      if (!g) return false;
      try { var a = gravurText(unb64(g[1])), b = gravurText(unb64(g[2])); Z.gr1 = a; Z.gr2 = b; return true; } catch (e) { return false; }
    }
    function urlSetzen(neuerSchritt) {
      try {
        var u = new URL(linkBauen(true));
        var alt = new URL(window.location.href);
        ['preise', 'testdaten'].forEach(function (k) { if (alt.searchParams.get(k)) u.searchParams.set(k, alt.searchParams.get(k)); });
        var state = Object.assign({}, history.state, { jbKonf: { root: root.id, schritt: Z.schritt, code: codeBauen(true) } });
        history[neuerSchritt ? 'pushState' : 'replaceState'](state, '', u.toString() + '#' + root.id);
      } catch (e) { /* egal */ }
      try { sessionStorage.setItem('jb_konf_stand', JSON.stringify({ code: Z.modell ? codeBauen() : '', schritt: Z.schritt })); }
      catch (e) { speicherWarnung('Ihr Browser speichert diese Auswahl nicht. Sichern Sie Ihren Code unter „Speichern“, bevor Sie die Seite verlassen.'); }
    }
    window.addEventListener('popstate', function (e) {
      var s = e.state && e.state.jbKonf;
      if (!D || !s || s.root !== root.id) return;
      // Browser-Zurück wechselt den Schritt. Änderungen rückgängig macht nur „Rückgängig“.
      if (!Z.modell && s.code && !codeLaden(s.code)) return;
      Z.schritt = Z.modell ? Math.max(1, Math.min(5, Number(s.schritt) || 1)) : 1;
      schliessen(); urlSetzen(); zeichnen(); schrittFokus();
    });

    /* ---------- Verlauf (Rückgängig / Zurücksetzen) ---------- */
    function schnappschuss() { return Object.assign({}, Z); }
    function merkenVerlauf() { verlauf.push(schnappschuss()); if (verlauf.length > 50) verlauf.shift(); }
    function aendern(fn) {
      var alterSchritt = Z.schritt;
      merkenVerlauf();
      fn();
      urlSetzen(alterSchritt !== Z.schritt);
      zeichnen();
    }
    function rueckgaengig() {
      if (!verlauf.length) return;
      Z = verlauf.pop();
      urlSetzen();
      zeichnen();
    }
    function zuruecksetzen() {
      merkenVerlauf();
      var m = Z.modell, s = Z.schritt;
      Z = Object.assign({ modell: m, schritt: s }, GRUND);
      if (m) passendeVariante();
      F = fLeer();
      urlSetzen();
      zeichnen();
    }

    /* ---------- Dialoge ---------- */
    var offenerDialog = null;
    var dialogFokus = null, inerteElemente = [];
    function dialog(titel, inhalt, breit) {
      schliessen();
      var vorher = document.activeElement;
      dialogFokus = vorher;
      var zu = knopf('×', 'jb-konf__dialog-zu', null, { 'aria-label': 'Schließen' });
      var box = el('div', { class: 'jb-konf__dialog' + (breit ? ' jb-konf__dialog--breit' : ''), role: 'dialog', 'aria-modal': 'true', 'aria-label': titel }, [
        el('div', { class: 'jb-konf__dialog-kopf' }, [el('h2', { text: titel }), zu]),
        el('div', { class: 'jb-konf__dialog-inhalt' }, [inhalt])
      ]);
      var hg = el('div', { class: 'jb-konf jb-konf__dialog-hg' }, [box]);
      function zuMachen() { schliessen(); if (vorher && vorher.focus && document.contains(vorher)) vorher.focus(); }
      zu.addEventListener('click', zuMachen);
      hg.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); zuMachen(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(box.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      hg.addEventListener('click', function (e) { if (e.target === hg) zuMachen(); });
      document.body.appendChild(hg);
      inerteElemente = Array.prototype.filter.call(document.body.children, function (n) { return n !== hg && !n.inert; });
      inerteElemente.forEach(function (n) { n.inert = true; });
      document.documentElement.classList.add('jb-konf-offen');
      offenerDialog = hg;
      zu.focus();
      return hg;
    }
    function schliessen() {
      if (offenerDialog) {
        offenerDialog.remove(); offenerDialog = null; document.documentElement.classList.remove('jb-konf-offen');
        inerteElemente.forEach(function (n) { n.inert = false; }); inerteElemente = [];
        if (dialogFokus && document.contains(dialogFokus)) dialogFokus.focus({ preventScroll: true });
      }
    }
    /* Esc außerhalb des Fensters (Fokus z. B. im Seitenhintergrund) schließt ebenfalls */
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && offenerDialog && !offenerDialog.contains(document.activeElement)) schliessen(); });

    function zoomDialog() {
      var m = Z.modell;
      var img = bild(m, 1200, 'Trauring Modell ' + m.m + ' groß', false);
      var rahmen = el('button', { type: 'button', class: 'jb-konf__zoom', 'aria-label': 'Bild heranzoomen', 'aria-pressed': 'false' }, [img]);
      rahmen.addEventListener('click', function () { var an = rahmen.classList.toggle('is-zoom'); rahmen.setAttribute('aria-pressed', String(an)); rahmen.setAttribute('aria-label', an ? 'Bild verkleinern' : 'Bild heranzoomen'); });
      rahmen.addEventListener('mousemove', function (e) {
        var r = rahmen.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      dialog('Modell ' + m.m, el('div', null, [rahmen, el('p', { class: 'jb-konf__hinweis', text: 'Bild antippen oder klicken zum Heranzoomen. Abbildung des Herstellers, kann vom Original abweichen.' })]), true);
      track('jb_konfigurator_aktion', { jb_aktion: 'zoom' });
    }

    function detailZeilen() {
      var m = Z.modell, p = preis(m, Z.legierung, Z.stein);
      var fw = wahlText(FARBWUNSCH, Z.farbwunsch), ob = wahlText(OBERFL, Z.oberflaeche), br = wahlText(BREITE, Z.breite);
      return [
        ['Modell', m.m, ''], ['Kollektion', kollName(m), ''],
        ['Farbe laut Abbildung', farbeText(m.c), ''], ['Farbwunsch', fw, ''],
        ['Oberfläche', ob, ''], ['Breite', br, ''],
        ['Legierung', LEG[Z.legierung], ''], ['Steinbesatz', STEIN[Z.stein] + ' (wie abgebildet)', ''],
        ['Ringgröße', Z.g1 ? groesseText(Z.g1) : 'noch offen', Z.g2 ? groesseText(Z.g2) : 'noch offen'],
        ['Gravur', Z.gr1 || '–', Z.gr2 || '–'],
        ['Schrift', Z.gr1 ? SCHRIFTEN[Z.f1][0] : '–', Z.gr2 ? SCHRIFTEN[Z.f2][0] : '–'],
        ['Vorsteckring', Z.vorsteck ? 'mit anfragen' : '–', ''],
        ['Preis je Ring', cfg.preise && p ? euro(p) + ' inkl. MwSt.' : 'auf Anfrage', '']
      ].concat(codeAn() && p ? [['Mit Code ' + cfg.aktion.code, euro(mitCode(p)) + ' je Ring (−' + cfg.aktion.prozent + ' %, Einlösung im Laden)', '']] : [])
        .concat(cfg.gravurarten.length ? [['Gravurart', gravurArtText(), '']] : [])
        .concat(paarAn() && p ? [['Paar (2 Ringe)', euro(2 * ep(p)) + ' (rechnerisch 2 × Preis je Ring' + (codeAn() ? ' mit Code' : '') + ')', '']] : [])
        .concat(cfg.lieferzeit ? [['Lieferzeit', cfg.lieferzeit, '']] : []);
    }
    function paarAn() { return cfg.preise && cfg.paar; }
    function gravurArtText() {
      var g = cfg.gravurarten[Z.gravurArt - 1];
      return g ? g.name + (g.preis ? ' (' + g.preis + ')' : '') : 'noch offen';
    }
    function detailTabelle() {
      var t = el('table', { class: 'jb-konf__tabelle' });
      t.appendChild(el('thead', null, [el('tr', null, [el('th', { scope: 'col', text: 'Auswahl' }), el('th', { scope: 'col', text: 'Ring 1' }), el('th', { scope: 'col', text: 'Ring 2' })])]));
      var tb = el('tbody');
      detailZeilen().forEach(function (z) {
        var tr = el('tr', null, [el('th', { scope: 'row', text: z[0] })]);
        if (z[2] === '') tr.appendChild(el('td', { colspan: '2', text: z[1] }));
        else { tr.appendChild(el('td', { text: z[1] })); tr.appendChild(el('td', { text: z[2] })); }
        tb.appendChild(tr);
      });
      t.appendChild(tb);
      return t;
    }
    function detailsDialog() {
      var inhalt = el('div', null, [detailTabelle()]);
      if (cfg.preise) inhalt.appendChild(el('p', { class: 'jb-konf__hinweis', text: cfg.preisHinweis }));
      dialog('Details Ihrer Konfiguration', inhalt, true);
      track('jb_konfigurator_aktion', { jb_aktion: 'details' });
    }

    function merkliste() {
      var l = speicherLesen('jb_konf_merkliste');
      return Array.isArray(l) ? l.filter(function (e) { return e && typeof e.code === 'string' && typeof e.titel === 'string' && typeof e.datum === 'string'; }).slice(0, 20) : [];
    }
    function geladenWeiter() { verlauf = []; schliessen(); Z.schritt = Math.max(2, Z.schritt); urlSetzen(); zeichnen(); schrittFokus(); }
    function merklisteEl(nachAenderung) {
      var liste = el('ul', { class: 'jb-konf__merkliste' });
      var l = merkliste();
      if (!l.length) liste.appendChild(el('li', { class: 'jb-konf__hinweis', text: 'Noch nichts gemerkt.' }));
      l.forEach(function (e, i) {
        liste.appendChild(el('li', null, [el('span', { text: e.titel + ' · ' + e.datum }),
          knopf('Laden', 'jb-konf__link', function () { if (codeLaden(e.code)) geladenWeiter(); }),
          knopf('Entfernen', 'jb-konf__link', function () { var a = merkliste(); a.splice(i, 1); speicherSchreiben('jb_konf_merkliste', a); nachAenderung(); })]));
      });
      return liste;
    }
    function ladeBlock() {
      var ladeFeld = el('input', { type: 'text', placeholder: 'Code oder Link einfügen', 'aria-label': 'Code oder Link zum Laden' });
      var meldung = el('p', { class: 'jb-konf__hinweis', 'aria-live': 'polite' });
      var laden = knopf('Konfiguration laden', 'jb-konf__btn jb-konf__btn--hell', function () {
        if (codeLaden(ladeFeld.value)) geladenWeiter(); else meldung.textContent = 'Dieser Code passt zu keiner Konfiguration. Bitte prüfen.';
      });
      var listeHalter = el('div');
      function liste() { listeHalter.textContent = ''; listeHalter.appendChild(merklisteEl(liste)); }
      liste();
      return { el: el('div', null, [el('h3', { text: 'Konfiguration laden' }), ladeFeld, el('div', { class: 'jb-konf__aktionen' }, [laden]), meldung,
        el('h3', { text: 'Gemerkt auf diesem Gerät' }), listeHalter]), neu: liste };
    }
    function speichernDialog() {
      if (!Z.modell) { dialog('Konfiguration laden', ladeBlock().el); return; }
      var code = codeBauen();
      var codeFeld = el('input', { type: 'text', readonly: true, value: code, class: 'jb-konf__code', 'aria-label': 'Ihr Konfigurations-Code' });
      var meldung = el('p', { class: 'jb-konf__hinweis', 'aria-live': 'polite' });
      var lb = ladeBlock();
      var merken = knopf('Auf diesem Gerät merken', 'jb-konf__btn', function () {
        var a = merkliste().filter(function (e) { return e.code !== code; });
        a.unshift({ code: code, titel: 'Modell ' + Z.modell.m + ', ' + LEG[Z.legierung] + ', ' + STEIN[Z.stein], datum: new Date().toLocaleDateString('de-DE') });
        meldung.textContent = speicherSchreiben('jb_konf_merkliste', a.slice(0, 20)) ? 'Gemerkt. Sie finden die Auswahl unter „Gemerkt auf diesem Gerät“.' : 'Merken ist in diesem Browser gesperrt. Kopieren Sie bitte den Code.';
        lb.neu();
        track('jb_konfigurator_aktion', { jb_aktion: 'speichern' });
      });
      var kopieren = knopf('Code kopieren', 'jb-konf__btn jb-konf__btn--hell', function () { kopiere(code, meldung, 'Code kopiert.'); });
      dialog('Laden / Speichern', el('div', { class: 'jb-konf__dialog-raster' }, [
        el('div', null, [el('h3', { text: 'Konfiguration speichern' }), el('p', { class: 'jb-konf__hinweis', text: 'Mit diesem Code laden Sie Ihre Ringe jederzeit wieder.' }), codeFeld,
          el('div', { class: 'jb-konf__aktionen' }, [merken, kopieren]), meldung]),
        lb.el
      ]), true);
    }
    function kopiere(text, meldung, ok) {
      function fallback() {
        var t = meldung.parentNode.querySelector('input[readonly]');
        if (t) { t.focus(); t.select(); }
        var kopiert = false;
        try { kopiert = !!document.execCommand('copy'); } catch (e) { /* manuell kopieren */ }
        meldung.textContent = kopiert ? ok : 'Automatisches Kopieren ist gesperrt. Bitte den markierten Text kopieren.';
      }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { meldung.textContent = ok; }, fallback);
      else fallback();
    }
    function teilenDialog(titel, erklaerung, url, text, betreff) {
      var feld = el('input', { type: 'text', readonly: true, value: url, class: 'jb-konf__code', 'aria-label': 'Link' });
      var meldung = el('p', { class: 'jb-konf__hinweis', 'aria-live': 'polite' });
      dialog(titel, el('div', null, [
        el('p', { class: 'jb-konf__hinweis', text: erklaerung }), feld,
        el('div', { class: 'jb-konf__aktionen' }, [
          knopf('Link kopieren', 'jb-konf__btn', function () { kopiere(url, meldung, 'Link kopiert.'); }),
          el('a', { class: 'jb-konf__btn jb-konf__btn--hell', href: 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), target: '_blank', rel: 'noopener', text: 'Per WhatsApp' }),
          el('a', { class: 'jb-konf__btn jb-konf__btn--hell', href: 'mailto:?subject=' + encodeURIComponent(betreff) + '&body=' + encodeURIComponent(text + '\n' + url), text: 'Per E-Mail' })
        ]), meldung]));
    }
    function mobilTeilen(titel, text, url, ersatz) {
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        navigator.share({ title: titel, text: text, url: url }).catch(function (e) { if (e.name !== 'AbortError') ersatz(); });
        return true;
      }
      return false;
    }
    function teilen(nurDialog) {
      var url = linkBauen();
      var text = 'Unsere Wunsch-Trauringe: Modell ' + Z.modell.m + ', ' + LEG[Z.legierung] + ', ' + STEIN[Z.stein];
      track('jb_konfigurator_aktion', { jb_aktion: 'teilen' });
      function ersatz() { teilenDialog('Konfiguration teilen', 'Der Link öffnet genau diese Ringe mit allen Einstellungen.', url, text, 'Unsere Wunsch-Trauringe'); }
      if (nurDialog === true || !mobilTeilen('Trauringe Juwelier Benjamin', text, url, ersatz)) ersatz();
    }
    function favTeilen() {
      if (!favs.length) return;
      var url = favLink();
      var text = 'Meine Lieblings-Trauringe bei Juwelier Benjamin (' + favs.length + '). Herzen setzen und unser Match sehen:';
      track('jb_konfigurator_aktion', { jb_aktion: 'favoriten_teilen', jb_anzahl: favs.length });
      function ersatz() { teilenDialog('Favoriten mit Partner teilen', 'Ihr Partner öffnet den Link, sieht ' + (favs.length === 1 ? 'Ihren Favoriten' : 'Ihre ' + favs.length + ' Favoriten') + ' und setzt eigene Herzen. Gemeinsame Favoriten erscheinen bei Ihnen beiden unter „Euer Match“, sobald Ihr Partner seinen Link zurückschickt.', url, text, 'Unsere Trauring-Favoriten'); }
      if (!mobilTeilen('Trauring-Favoriten', text, url, ersatz)) ersatz();
    }
    var druckBereich = null;
    function druckFlaeche(zusatz) {
      if (!druckBereich) { druckBereich = el('div'); document.body.appendChild(druckBereich); }
      druckBereich.className = 'jb-konf jb-konf__druck' + (zusatz ? ' ' + zusatz : '');
      druckBereich.textContent = '';
      return druckBereich;
    }
    function drucken() {
      druckFlaeche();
      var m = Z.modell;
      druckBereich.appendChild(el('h2', { text: 'Ihre Trauringe bei Juwelier Benjamin' }));
      druckBereich.appendChild(el('div', { class: 'jb-konf__druck-kopf' }, [bild(m, 600, 'Trauring Modell ' + m.m, false), detailTabelle()]));
      druckBereich.appendChild(el('p', { text: 'Link zu dieser Konfiguration: ' + linkBauen() }));
      if (cfg.telefonText) druckBereich.appendChild(el('p', { text: 'Juwelier Benjamin · Telefon ' + cfg.telefonText }));
      druckBereich.appendChild(el('p', { class: 'jb-konf__hinweis', text: 'Modelle und Bilder: CILOR Trauringmanufaktur. Abbildungen können vom Original abweichen.' }));
      document.documentElement.classList.add('jb-konf-druckt');
      track('jb_konfigurator_aktion', { jb_aktion: 'drucken' });
      var img = druckBereich.querySelector('img');
      var gedruckt = false, druckTimer;
      var los = function () { if (gedruckt) return; gedruckt = true; clearTimeout(druckTimer); window.print(); };
      druckTimer = setTimeout(los, 3000);
      if (img && !img.complete) { img.addEventListener('load', los, { once: true }); img.addEventListener('error', los, { once: true }); } else los();
    }
    window.addEventListener('afterprint', function () { document.documentElement.classList.remove('jb-konf-druckt'); });

    /* Messhilfe zum Ausdrucken: alle Maße in Millimetern. Stimmt nur bei 100 % Druckgröße, deshalb die Prüflinie. */
    function mmText(x, y, text, groesse, anker) { return svgEl('text', { x: String(x), y: String(y), 'font-size': String(groesse || 2.6), 'text-anchor': anker || 'middle', fill: '#2b2b38', text: text }); }
    function messhilfeDrucken() {
      var f = druckFlaeche('jb-konf__druck--mass');
      f.appendChild(el('h2', { text: 'Ringmaß-Hilfe von Juwelier Benjamin' }));
      f.appendChild(el('p', { class: 'jb-konf__mass-warnung', text: 'Bitte zuerst prüfen: Legen Sie eine EC- oder Kreditkarte an die Linie. Die Karte muss genau so lang sein. Wenn nicht, beim Drucken „Tatsächliche Größe“ bzw. 100 % wählen und neu drucken.' }));
      f.appendChild(el('div', { class: 'jb-konf__mass-pruef' }, [el('div', { class: 'jb-konf__pruef-linie', 'data-mm': '85.6' }), el('span', { text: '85,6 mm = Breite einer EC- oder Kreditkarte' })]));
      var streifen = svgEl('svg', { class: 'jb-konf__mass-streifen', viewBox: '0 0 104 24', width: '104mm', height: '24mm' }, [
        svgEl('rect', { x: '0.2', y: '2', width: '103.6', height: '14', fill: '#fff', stroke: '#2b2b38', 'stroke-width': '0.25', 'stroke-dasharray': '1.2 0.8' })]);
      for (var i = 0; i <= 100; i++) {
        var lang = i % 10 === 0 ? 6 : i % 5 === 0 ? 4.5 : 2.5;
        streifen.appendChild(svgEl('line', { x1: String(i + 0.2), x2: String(i + 0.2), y1: '16', y2: String(16 - lang), stroke: '#2b2b38', 'stroke-width': i % 5 === 0 ? '0.22' : '0.12' }));
        if (i && (i % 10 === 0 || (i >= 40 && i <= 80 && i % 2 === 0))) streifen.appendChild(mmText(i + 0.2, i >= 40 && i <= 80 && i % 4 === 2 ? 4.4 : 7.4, String(i), 2.1));
      }
      streifen.appendChild(mmText(1, 21, '◀ hier beginnen', 2.4, 'start'));
      streifen.appendChild(mmText(103, 21, 'Zahl an der Markierung = Ringgröße', 2.4, 'end'));
      f.appendChild(el('h3', { text: '1. Messstreifen: für den Finger' }));
      f.appendChild(el('ol', { class: 'jb-konf__anleitung' }, [
        el('li', { text: 'Streifen an der gestrichelten Linie ausschneiden.' }),
        el('li', { text: 'Am Anfang („hier beginnen“) eng, aber nicht zu fest um den Finger legen, an der Stelle, an der der Ring sitzen soll.' }),
        el('li', { text: 'Die Stelle markieren, an der sich der Streifen überlappt. Die Zahl dort ist der Umfang in mm und damit Ihre Ringgröße.' })]));
      f.appendChild(streifen);
      var kreise = svgEl('svg', { class: 'jb-konf__mass-kreise', viewBox: '0 0 170 96', width: '170mm', height: '96mm' });
      for (var k = 0; k < 15; k++) {
        var gr = 46 + k * 2, d = gr / Math.PI, cx = 17 + (k % 5) * 34, cy = 14 + Math.floor(k / 5) * 32;
        kreise.appendChild(svgEl('circle', { cx: String(cx), cy: String(cy), r: (d / 2).toFixed(3), fill: 'none', stroke: '#2b2b38', 'stroke-width': '0.2' }));
        kreise.appendChild(svgEl('line', { x1: String(cx - 1), x2: String(cx + 1), y1: String(cy), y2: String(cy), stroke: '#2b2b38', 'stroke-width': '0.12' }));
        kreise.appendChild(svgEl('line', { x1: String(cx), x2: String(cx), y1: String(cy - 1), y2: String(cy + 1), stroke: '#2b2b38', 'stroke-width': '0.12' }));
        kreise.appendChild(mmText(cx, cy + 15, 'Größe ' + gr + ' · Ø ' + d.toFixed(1).replace('.', ',') + ' mm', 2.4));
      }
      f.appendChild(el('h3', { text: '2. Kreise: für einen Ring, der schon gut passt' }));
      f.appendChild(el('p', { text: 'Ring flach auf die Kreise legen. Der Kreis, dessen Linie genau an der Innenkante des Rings liegt, zeigt Ihre Größe. Liegt er zwischen zwei Kreisen, nehmen Sie den größeren.' }));
      f.appendChild(kreise);
      f.appendChild(el('p', { class: 'jb-konf__mass-fuss', text: 'Nur zur Orientierung: Papier dehnt sich, Finger sind morgens und abends unterschiedlich dick. Die genaue Größe messen wir gern bei Ihnen im Laden: Juwelier Benjamin, Wilhelmstraße 52, Wiesbaden' + (cfg.telefonText ? ', Telefon ' + cfg.telefonText : '') + '. Ihre gemessene Zahl tragen Sie im Konfigurator unter „Größe ermitteln“ ein.' }));
      document.documentElement.classList.add('jb-konf-druckt');
      track('jb_konfigurator_aktion', { jb_aktion: 'messhilfe_drucken' });
      window.print();
    }

    function groesseDialog() {
      var feld = el('input', { type: 'number', min: '40', max: '80', step: '0.5', inputmode: 'decimal', placeholder: 'z. B. 54', id: 'jbumfang-' + root.id });
      var erg = el('p', { class: 'jb-konf__groesse-erg', 'aria-live': 'polite' });
      var gefunden = 0;
      var k1 = knopf('Für Ring 1 übernehmen', 'jb-konf__btn', function () { if (gefunden) { schliessen(); aendern(function () { Z.g1 = gefunden; }); } }, { disabled: true });
      var k2 = knopf('Für Ring 2 übernehmen', 'jb-konf__btn jb-konf__btn--hell', function () { if (gefunden) { schliessen(); aendern(function () { Z.g2 = gefunden; }); } }, { disabled: true });
      feld.addEventListener('input', function () {
        var u = parseFloat(String(feld.value).replace(',', '.'));
        gefunden = 0;
        if (u >= 46 && u <= 74) { gefunden = Math.round(u * 2) / 2; erg.textContent = 'Passende Ringgröße: ' + groesseText(gefunden); }
        else if (u) erg.textContent = 'Die Größenhilfe rechnet von 46 bis 74 mm Umfang. Bitte prüfen Sie Ihre Messung oder lassen Sie Ihre Größe bei uns bestimmen.';
        else erg.textContent = '';
        k1.disabled = k2.disabled = !gefunden;
      });
      dialog('Ringgröße ermitteln', el('div', null, [
        el('ol', { class: 'jb-konf__anleitung' }, [
          el('li', { text: 'Einen schmalen Papierstreifen eng, aber nicht zu fest um den Finger legen, an der Stelle, an der der Ring sitzen soll.' }),
          el('li', { text: 'Die Stelle markieren, an der sich das Papier überlappt.' }),
          el('li', { text: 'Den Streifen flach hinlegen und die Länge bis zur Markierung in Millimetern messen.' })
        ]),
        el('label', { class: 'jb-konf__label', for: 'jbumfang-' + root.id, text: 'Gemessener Umfang in mm' }), feld, erg,
        el('div', { class: 'jb-konf__aktionen' }, [k1, k2]),
        el('p', { class: 'jb-konf__hinweis', text: 'Eine Papiermessung ist nur eine Orientierung. Die passende Größe bestimmen wir gemeinsam im Laden.' }),
        el('h3', { text: 'Messhilfe zum Ausdrucken' }),
        el('p', { class: 'jb-konf__hinweis', text: 'Messstreifen für den Finger und Kreise für einen vorhandenen Ring, mit Prüflinie für die richtige Druckgröße.' }),
        el('div', { class: 'jb-konf__aktionen' }, [knopf('Messhilfe drucken', 'jb-konf__btn jb-konf__btn--hell', messhilfeDrucken)])
      ]));
      feld.focus();
    }

    /* ---------- Kurzmeldung (Herz, Vergleich) ---------- */
    var toastEl = el('p', { class: 'jb-konf__toast', role: 'status', 'aria-live': 'polite', hidden: true });
    root.appendChild(toastEl);
    var toastTimer;
    function toast(text) {
      toastEl.textContent = text; toastEl.hidden = false;
      clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4000);
    }

    /* ---------- Paar-Modus: Favoriten, Partner-Liste, Euer Match ---------- */
    function nrListe(l, max) {
      var aus = [];
      if (!Array.isArray(l)) return aus;
      l.forEach(function (x) {
        var m = typeof x === 'string' && x.length <= 20 ? modellZuNr(x) : null;
        if (m && aus.indexOf(m.m) < 0 && aus.length < max) aus.push(m.m);
      });
      return aus;
    }
    function merkLaden() {
      favs = nrListe(speicherLesen('jb_konf_favs'), FAV_MAX);
      partner = nrListe(speicherLesen('jb_konf_partner'), FAV_MAX);
      var v = null;
      try { v = JSON.parse(sessionStorage.getItem('jb_konf_vergleich') || 'null'); } catch (e) { v = null; }
      vergleich = nrListe(v, VGL_MAX);
    }
    function merkSichern(k, wert) {
      if (speicherSchreiben(k, wert)) return true;
      if (!merkSpeicherAus) { merkSpeicherAus = true; speicherWarnung('Ihr Browser speichert Favoriten nicht dauerhaft. Teilen Sie Ihre Favoriten per Link, dann gehen sie nicht verloren.'); }
      return false;
    }
    function istFav(m) { return favs.indexOf(m.m) >= 0; }
    function matchListe() { return favs.filter(function (n) { return partner.indexOf(n) >= 0; }); }
    function merkAktualisieren() {
      var a = document.activeElement, id = a && root.contains(a) ? a.id : '';
      if (Z.schritt === 1 || !Z.modell) { if (merkNeu) merkNeu(); if (vglNeu) vglNeu(); if (rasterNeu) rasterNeu(); }
      else zeichnen();
      if (id) { var f = document.getElementById(id); if (f && f !== document.activeElement) f.focus({ preventScroll: true }); }
    }
    function favUmschalten(m) {
      var i = favs.indexOf(m.m);
      if (i >= 0) favs.splice(i, 1);
      else if (favs.length >= FAV_MAX) { toast('Sie haben schon ' + FAV_MAX + ' Favoriten. Entfernen Sie zuerst ein Herz.'); return; }
      else favs.push(m.m);
      merkSichern('jb_konf_favs', favs);
      track('jb_konfigurator_aktion', { jb_aktion: i >= 0 ? 'favorit_entfernt' : 'favorit', jb_anzahl: favs.length });
      if (i < 0 && partner.indexOf(m.m) >= 0) {
        toast('Euer Match: Modell ' + m.m + ' gefällt Ihnen beiden.');
        track('jb_konfigurator_aktion', { jb_aktion: 'match', jb_anzahl: matchListe().length });
      } else toast(i >= 0 ? 'Modell ' + m.m + ' aus Ihren Favoriten entfernt.' : 'Modell ' + m.m + ' gemerkt (' + favs.length + ' Favoriten).');
      merkAktualisieren();
    }
    function favLink() {
      var u = new URL(window.location.href);
      ['modell', 'konf', 'contact_posted', 'preise', 'testdaten', 'favs', 'code'].forEach(function (k) { u.searchParams.delete(k); });
      u.hash = '';
      u.searchParams.set('favs', favs.map(function (n) { return n.replace(/\s+/g, '_'); }).join('.'));
      return u.toString();
    }
    function favsAusLink(roh) {
      roh = String(roh || '');
      var teile = [];
      if (roh.length <= 600) roh.split('.').forEach(function (t) { if (t && teile.map(nrNorm).indexOf(nrNorm(t)) < 0) teile.push(t); });
      var gueltig = teile.length && teile.length <= FAV_MAX ? nrListe(teile.filter(function (t) { return /^[A-Za-z0-9_]{1,20}$/.test(t); }), FAV_MAX) : [];
      if (!gueltig.length) { hinweis('Dieser Favoriten-Link enthält keine gültigen Modelle. Bitten Sie Ihren Partner, den Link noch einmal zu schicken.'); return false; }
      partner = gueltig;
      merkSichern('jb_konf_partner', partner);
      F.liste = 'partner';
      hinweis((gueltig.length < teile.length ? gueltig.length + ' von ' + teile.length + ' Modellen gefunden. ' : '') +
        'Ihr Partner hat ' + (gueltig.length === 1 ? 'einen Lieblingsring' : gueltig.length + ' Lieblingsringe') + ' geteilt. Tippen Sie bei Ihren Favoriten auf das Herz. Gemeinsame Herzen erscheinen unter „Euer Match“.', true);
      track('jb_konfigurator_aktion', { jb_aktion: 'favoriten_link', jb_anzahl: gueltig.length });
      return true;
    }
    function merkGruppe(halter) {
      halter.textContent = '';
      /* Erst sichtbar, wenn es etwas zu zeigen gibt: ab dem ersten Herz oder mit einem Partner-Link. */
      halter.hidden = !favs.length && !partner.length;
      var werte = [['', 'Alle Modelle'], ['meine', 'Meine Favoriten (' + favs.length + ')']];
      if (partner.length) werte.push(['partner', 'Favoriten Ihres Partners (' + partner.length + ')'], ['match', 'Euer Match (' + matchListe().length + ')']);
      halter.appendChild(chipGruppe('Merkliste', werte, F.liste, function (v) { F.liste = v; F.sichtbar = cfg.proSeite; zeichnen(); }));
      var zeile = el('div', { class: 'jb-konf__merk-zeile' });
      zeile.appendChild(knopf('Favoriten mit Partner teilen', 'jb-konf__link', function () { favTeilen(); }, { disabled: !favs.length, hidden: !favs.length, id: 'jbfavteilen-' + root.id }));
      /* erst neu zeichnen (Fokus bleibt per ID), dann öffnen: so kehrt der Fokus nach dem Schließen hierher zurück */
      zeile.appendChild(knopf('Favoriten vergleichen', 'jb-konf__link', function () { vergleich = favs.slice(0, VGL_MAX); vglSichern(); merkAktualisieren(); vergleichDialog(); },
        { disabled: favs.length < 2, hidden: favs.length < 2, id: 'jbfavvgl-' + root.id }));
      halter.appendChild(zeile);
    }

    /* ---------- Vergleich (bis zu 3 Modelle) ---------- */
    function vglSichern() { try { sessionStorage.setItem('jb_konf_vergleich', JSON.stringify(vergleich)); } catch (e) { /* gilt dann nur für diesen Besuch */ } }
    function imVergleich(m) { return vergleich.indexOf(m.m) >= 0; }
    function vglUmschalten(m) {
      var i = vergleich.indexOf(m.m);
      if (i >= 0) vergleich.splice(i, 1);
      else if (vergleich.length >= VGL_MAX) { toast('Sie können bis zu 3 Modelle vergleichen. Entfernen Sie zuerst eins.'); return; }
      else vergleich.push(m.m);
      vglSichern();
      track('jb_konfigurator_aktion', { jb_aktion: i >= 0 ? 'vergleich_entfernt' : 'vergleich', jb_anzahl: vergleich.length });
      toast(i >= 0 ? 'Modell ' + m.m + ' aus dem Vergleich entfernt.' : 'Modell ' + m.m + ' im Vergleich (' + vergleich.length + ' von 3).');
      merkAktualisieren();
    }
    function vglLeiste(halter) {
      halter.textContent = '';
      halter.hidden = !vergleich.length;
      if (!vergleich.length) return;
      halter.appendChild(el('span', { class: 'jb-konf__vgl-text', text: 'Vergleich: ' + vergleich.join(', ') + ' (' + vergleich.length + ' von 3)' }));
      if (vergleich.length > 1) halter.appendChild(knopf('Vergleichen', 'jb-konf__btn', vergleichDialog));
      else halter.appendChild(el('span', { class: 'jb-konf__hinweis', text: 'Weiteres Modell öffnen und „Vergleichen“ tippen.' }));
      halter.appendChild(knopf('Leeren', 'jb-konf__link', function () { vergleich = []; vglSichern(); merkAktualisieren(); }));
    }
    function vergleichDialog() {
      var halter = el('div');
      function fuellen() {
        halter.textContent = '';
        var ms = vergleich.map(modellZuNr).filter(Boolean), n = ms.length, zi = 0;
        var t = el('table', { class: 'jb-konf__vergleich' });
        var kopf = el('tr');
        ms.forEach(function (m, i) { kopf.appendChild(el('th', { scope: 'col', id: 'jbvglk-' + i + '-' + root.id, text: 'Modell ' + m.m })); });
        t.appendChild(el('thead', null, [kopf]));
        var tb = el('tbody');
        function zeile(titel, werte, fett) {
          var tid = 'jbvglz-' + (zi++) + '-' + root.id;
          if (titel) tb.appendChild(el('tr', { class: 'jb-konf__vgl-titel' }, [el('th', { colspan: String(n), id: tid, text: titel })]));
          var tr = el('tr');
          werte.forEach(function (w, i) { tr.appendChild(el('td', { headers: 'jbvglk-' + i + '-' + root.id + (titel ? ' ' + tid : ''), class: fett && fett[i] ? 'is-guenstig' : null }, [w])); });
          tb.appendChild(tr);
        }
        zeile('', ms.map(function (m) { return bild(m, 280, 'Trauring Modell ' + m.m, false); }));
        zeile('Kollektion', ms.map(kollName));
        zeile('Farbe laut Abbildung', ms.map(function (m) { return farbeText(m.c); }));
        if (cfg.preise) {
          var ab = ms.map(function (m) { return ep(abPreis(m)); });
          zeile('Preis je Ring ab', ab.map(function (p) { return p ? euro(p) : 'auf Anfrage'; }), guenstigste(ab));
          for (var l = 0; l < 3; l++) for (var s = 0; s < 3; s++) {
            var pr = ms.map(function (m) { return ep(preis(m, l, s)); });
            zeile(LEG[l] + ' · ' + STEIN[s], pr.map(function (p) { return p ? euro(p) : 'auf Anfrage'; }), guenstigste(pr));
          }
        } else zeile('Preis', ms.map(function () { return 'auf Anfrage'; }));
        zeile('', ms.map(function (m) {
          return el('div', { class: 'jb-konf__vgl-aktionen' }, [
            knopf('Dieses nehmen', 'jb-konf__btn', function () { schliessen(); waehle(m, 2); }, { 'aria-label': 'Modell ' + m.m + ' nehmen' }),
            knopf('Entfernen', 'jb-konf__link', function () {
              vglUmschalten(m);
              if (vergleich.length) { fuellen(); offenerDialog.querySelector('.jb-konf__dialog-zu').focus(); } else schliessen();
            }, { 'aria-label': 'Modell ' + m.m + ' aus dem Vergleich entfernen' })]);
        }));
        t.appendChild(tb);
        halter.appendChild(t);
        halter.appendChild(el('p', { class: 'jb-konf__hinweis', text: 'Farbe laut Herstellerfoto, Steinbesatz wie abgebildet.' + (cfg.preise ? ' Preise je Ring inkl. MwSt.' + (codeAn() ? ' mit Code ' + cfg.aktion.code : '') + ', der günstigste Wert je Zeile ist fett.' : ' Preise nennen wir Ihnen persönlich.') }));
      }
      fuellen();
      dialog('Modelle vergleichen', halter, true);
      track('jb_konfigurator_aktion', { jb_aktion: 'vergleich_ansehen', jb_anzahl: vergleich.length });
    }
    function guenstigste(werte) {
      var min = Math.min.apply(null, werte.filter(function (p) { return p > 0; }).concat([Infinity]));
      return werte.map(function (p) { return p > 0 && p === min && werte.length > 1; });
    }

    /* ---------- Ring-Finder ---------- */
    function farbePasst(m, f) { if (!f) return true; if (f === 'bi') return (m.c || '').length > 1; return m.c === f; }
    function finderPreis(m, a) {
      var best = { p: 0, l: -1, s: -1 };
      [0, 1, 2].forEach(function (l) {
        if (a.leg >= 0 && l !== a.leg) return;
        [0, 1, 2].forEach(function (s) {
          if (a.stein >= 0 && s !== a.stein) return;
          var p = ep(preis(m, l, s));
          if (p && (!best.p || p < best.p)) best = { p: p, l: l, s: s };
        });
      });
      return best;
    }
    function finderErgebnis(a) {
      var budget = cfg.preise ? a.budget : 0, treffer = [], nahe = [];
      D.modelle.forEach(function (m) {
        var fp = finderPreis(m, a), farbeOk = farbePasst(m, a.farbe);
        var ueber = budget ? (fp.p ? Math.max(0, fp.p - budget) : -1) : 0;
        if (farbeOk && ueber === 0) treffer.push({ m: m, fp: fp });
        else if (ueber >= 0) nahe.push({ m: m, fp: fp, ueber: ueber, farbeOk: farbeOk });
      });
      function nachPreis(x, y) { return (x.fp.p || 1e9) - (y.fp.p || 1e9); }
      if (treffer.length) { if (cfg.preise) treffer.sort(nachPreis); return { liste: treffer, exakt: true }; }
      nahe.sort(function (x, y) { return (x.farbeOk ? 0 : 1) - (y.farbeOk ? 0 : 1) || x.ueber - y.ueber || nachPreis(x, y); });
      return { liste: nahe.slice(0, 8), exakt: false };
    }
    function finderGrund(x) {
      var g = [];
      if (x.ueber > 0) g.push(euro(x.ueber) + ' über Ihrem Budget');
      if (x.farbeOk === false) g.push('andere Farbe: ' + farbeText(x.m.c));
      return g.join(' · ');
    }
    function finderText(a) {
      var t = [];
      if (cfg.preise) t.push(a.budget ? 'bis ' + euro(a.budget) + ' je Ring' : 'Budget egal');
      t.push(a.farbe ? FINDER_FARBE.filter(function (x) { return x[0] === a.farbe; })[0][1] : 'Farbe egal');
      t.push(a.stein >= 0 ? STEIN[a.stein] : 'Steine egal');
      t.push(a.leg >= 0 ? LEG[a.leg] : 'Goldgehalt offen');
      return t.join(' · ');
    }
    function finderDialog() {
      var fragen = [];
      if (cfg.preise) fragen.push({ k: 'budget', t: 'Wie viel möchten Sie je Ring ausgeben?', w: FINDER_BUDGET, i: 'Preis je Ring inkl. MwSt. Ihr persönliches Angebot für das Ringpaar besprechen wir mit Ihnen.' });
      fragen.push({ k: 'farbe', t: 'Welche Goldfarbe gefällt Ihnen?', w: FINDER_FARBE, i: 'Wir suchen nach der Farbe auf dem Herstellerfoto. Viele Modelle gibt es auf Wunsch auch in anderen Farben.' });
      fragen.push({ k: 'stein', t: 'Sollen Steine im Ring sein?', w: FINDER_STEIN, i: 'Jedes Modell mit Preisangabe gibt es laut Hersteller ohne Steine, mit Zirkonia oder mit Brillant, die Steinposition wie abgebildet. Ihre Antwort bestimmt Preis und Vorauswahl.' });
      fragen.push({ k: 'leg', t: 'Welcher Goldgehalt?', w: FINDER_LEG, i: '333, 585 und 750 nennen den Goldanteil in Tausendsteln. Mehr Gold kostet mehr. Bei „Weiß ich nicht“ zählt der günstigste Goldgehalt.' });
      var a = Object.assign({ budget: 0, farbe: '', stein: -1, leg: -1 }, F.finder || {});
      var beantwortet = F.finder ? { budget: 1, farbe: 1, stein: 1, leg: 1 } : {};
      var i = 0, halter = el('div', { class: 'jb-konf__finder' });
      function fertig() {
        var vorher = F;
        F = fLeer(); F.finder = a; F.sort = vorher.sort;
        var res = finderErgebnis(a);
        track('jb_konfigurator_aktion', { jb_aktion: 'finder', jb_anzahl: res.exakt ? res.liste.length : 0 });
        schliessen();
        if (Z.schritt !== 1) Z.schritt = 1;
        urlSetzen(); zeichnen();
        var b = app.querySelector('.jb-konf__finder-info strong');
        if (b) { b.setAttribute('tabindex', '-1'); b.focus({ preventScroll: true }); }
        nachOben();
      }
      function zeigen() {
        halter.textContent = '';
        var f = fragen[i];
        halter.appendChild(el('p', { class: 'jb-konf__finder-schritt', text: 'Frage ' + (i + 1) + ' von ' + fragen.length }));
        var fs = el('fieldset', { class: 'jb-konf__gruppe' }, [el('legend', { text: f.t })]);
        var box = el('div', { class: 'jb-konf__finder-optionen' });
        f.w.forEach(function (w, j) {
          box.appendChild(knopf(w[1], 'jb-konf__finder-opt', function () {
            a[f.k] = w[0]; beantwortet[f.k] = 1;
            if (i < fragen.length - 1) { i++; zeigen(); } else fertig();
          }, { 'aria-pressed': String(!!beantwortet[f.k] && a[f.k] === w[0]), id: 'jbfinder-' + f.k + '-' + j + '-' + root.id }));
        });
        fs.appendChild(box);
        halter.appendChild(fs);
        halter.appendChild(el('p', { class: 'jb-konf__hinweis', text: f.i }));
        halter.appendChild(el('div', { class: 'jb-konf__aktionen' }, [
          knopf('Zurück', 'jb-konf__btn jb-konf__btn--hell', function () { i--; zeigen(); }, { disabled: i === 0 })]));
        var erster = box.querySelector('[aria-pressed="true"]') || box.firstChild;
        if (offenerDialog) erster.focus();
      }
      dialog('Ring-Finder', halter);
      zeigen();
    }

    /* ---------- Navigation ---------- */
    function schritt(n) {
      if (n > 1 && !Z.modell) n = 1;
      n = Math.max(1, Math.min(5, n));
      if (n !== 2 || Z.schritt !== 2) { edelmetallBestaetigt = false; steinBestaetigt = false; }
      var anders = Z.schritt !== n; Z.schritt = n;
      urlSetzen(anders);
      if (!gemeldet[n]) { gemeldet[n] = true; track('jb_konfigurator_schritt', { jb_schritt: n }); }
      zeichnen();
      schrittFokus();
    }
    function schrittFokus() {
      var h = app.querySelector('.jb-konf__panel-kopf h2, .jb-konf__panel-kopf h3');
      if (h) h.focus({ preventScroll: true });
      nachOben();
    }
    function nachOben() {
      var panel = app.querySelector('.jb-konf__panel') || app;
      var top = panel.getBoundingClientRect().top + window.pageYOffset - navEl.offsetHeight - (parseFloat(root.style.getPropertyValue('--jb-konf-top')) || 0) - 12;
      try { window.scrollTo({ top: Math.max(0, top), behavior: 'instant' }); } catch (e) { window.scrollTo(0, Math.max(0, top)); }
    }
    function navZeichnen() {
      navEl.textContent = '';
      var ol = el('ol', { class: 'jb-konf__steps', 'aria-label': 'Schritte' });
      SCHRITTE.forEach(function (t, i) {
        var n = i + 1;
        var b = knopf('', 'jb-konf__step', function () { schritt(n); }, { disabled: n > 1 && !Z.modell, 'aria-label': 'Schritt ' + n + ' ' + t, 'aria-current': Z.schritt === n ? 'step' : null });
        b.appendChild(el('span', { class: 'jb-konf__step-nr', text: (n < Z.schritt && Z.modell) ? '✓' : String(n) }));
        b.appendChild(document.createTextNode(' '));
        b.appendChild(el('span', { class: 'jb-konf__step-text', text: t }));
        ol.appendChild(el('li', { class: Z.schritt === n ? 'is-aktiv' : (n < Z.schritt ? 'is-fertig' : '') }, [b]));
      });
      /* Rückgängig und Neu beginnen nur zeigen, wenn es etwas zu tun gibt */
      var werkzeuge = el('div', { class: 'jb-konf__werkzeuge', hidden: !Z.modell && !verlauf.length }, [
        knopf('↶ Rückgängig', 'jb-konf__link', rueckgaengig, { disabled: !verlauf.length, hidden: !verlauf.length }),
        knopf('↻ Zurücksetzen', 'jb-konf__link', zuruecksetzen, { hidden: !Z.modell })
      ]);
      navEl.appendChild(el('div', { class: 'jb-konf__navzeile' }, [ol]));
      navEl.appendChild(werkzeuge);
    }
    function kopfZeile(n) {
      /* Schritt 1: sichtbar führt die Schrittleiste, die Überschrift bleibt für Screenreader und Fokus */
      if (n === 1) return el('div', { class: 'jb-konf__kopf-leise' }, [el('div', { class: 'jb-konf__panel-kopf' }, [el(root.querySelector('h1') ? 'h2' : 'h3', { tabindex: '-1', text: '1. ' + SCHRITTE[0] })])]);
      var hid = 'jbhilfe-' + n + '-' + root.id;
      var hilfe = el('p', { class: 'jb-konf__hilfe-text', hidden: true, id: hid, text: HILFE[n] });
      var hb = knopf('?', 'jb-konf__hilfe', function () { hilfe.hidden = !hilfe.hidden; hb.setAttribute('aria-expanded', String(!hilfe.hidden)); },
        { 'aria-label': 'Hilfe zu diesem Schritt', 'aria-expanded': 'false', 'aria-controls': hid });
      return el('div', null, [el('div', { class: 'jb-konf__panel-kopf' }, [el(root.querySelector('h1') ? 'h2' : 'h3', { tabindex: '-1', text: n + '. ' + SCHRITTE[n - 1] }), hb]), hilfe]);
    }

    /* ---------- Schritt 1: Modell ---------- */
    function filterLeer() { F = fLeer(); }
    function gefiltert() {
      if (F.finder) return finderErgebnis(F.finder).liste.map(function (x) { return x.m; });
      var q = nrNorm(F.suche.trim());
      var merk = F.liste === 'meine' ? favs : F.liste === 'partner' ? partner : F.liste === 'match' ? matchListe() : null;
      var l = D.modelle.filter(function (m) {
        if (merk && merk.indexOf(m.m) < 0) return false;
        if (F.kollektion >= 0 && m.k !== F.kollektion) return false;
        if (F.farbe === 'bi' && (m.c || '').length < 2) return false;
        if (F.farbe && F.farbe !== 'bi' && m.c !== F.farbe) return false;
        if (cfg.preise && F.maxPreis && !(abPreis(m) && ep(abPreis(m)) <= F.maxPreis)) return false;
        if (q && nrNorm(m.m).indexOf(q) === -1 && nrNorm(kollName(m)).indexOf(q) === -1) return false;
        return true;
      });
      if (cfg.preise && F.sort) {
        l = l.slice().sort(function (a, b) {
          var pa = ep(abPreis(a)) || 1e9, pb = ep(abPreis(b)) || 1e9;
          if (F.sort === 'auf') return pa - pb;
          return pa === pb ? 0 : pa === 1e9 ? 1 : pb === 1e9 ? -1 : pb - pa;
        });
      }
      return l;
    }
    function chipGruppe(label, werte, aktiv, setzen) {
      var g = el('div', { class: 'jb-konf__chips', role: 'group', 'aria-label': label });
      werte.forEach(function (w, i) {
        var b = knopf(w[1], 'jb-konf__chip', function () { setzen(w[0]); }, { 'aria-pressed': String(aktiv === w[0]), id: 'jbchip-' + label.replace(/\W/g, '') + '-' + i + '-' + root.id });
        if (w[2]) b.insertBefore(el('span', { class: 'jb-konf__farbpunkt jb-konf__farbpunkt--' + w[2], 'aria-hidden': 'true' }), b.firstChild);
        g.appendChild(b);
      });
      return g;
    }
    function kartenKnoepfe(li, m) {
      var fav = istFav(m);
      var herz = knopf('', 'jb-konf__herz' + (fav ? ' is-an' : ''), function () { favUmschalten(m); },
        { 'aria-pressed': String(fav), 'aria-label': 'Modell ' + m.m + ' merken', title: fav ? 'Gemerkt' : 'Merken', id: 'jbfav-' + m.nr + '-' + root.id });
      herz.appendChild(herzIcon());
      li.appendChild(herz);
    }
    /* Anruf als Link, zählt wie der Anruf-Link im Formular (jb_trauring_kontakt) */
    function anrufLink(text, cls) {
      if (!cfg.telefonLink) return null;
      var a = el('a', { href: 'tel:' + cfg.telefonLink, class: cls, text: text, 'data-jb-contact': 'phone' });
      a.addEventListener('click', function () { track('jb_trauring_kontakt', { jb_kontaktweg: 'phone' }); });
      return a;
    }
    function filterAnzahl() { return (F.kollektion >= 0 ? 1 : 0) + (F.farbe ? 1 : 0) + (cfg.preise && F.maxPreis ? 1 : 0) + (cfg.preise && F.sort ? 1 : 0); }
    function schritt1(ziel) {
      var suche = el('input', { type: 'search', class: 'jb-konf__suche', placeholder: 'Modellnummer suchen', 'aria-label': 'Modellnummer suchen', value: F.suche, autocomplete: 'off', id: 'jbsuche-' + root.id });
      suche.addEventListener('input', function () { F.suche = suche.value; F.sichtbar = cfg.proSeite; clearTimeout(suchTimer); suchTimer = setTimeout(raster, 180); });
      var panelId = 'jbfilter-' + root.id, nf = filterAnzahl();
      var filterKnopf = knopf(nf ? 'Filter (' + nf + ')' : 'Filter', 'jb-konf__filter-k' + (nf ? ' is-aktiv' : ''), function () { filterOffen = !filterOffen; zeichnen(); },
        { 'aria-expanded': String(filterOffen), 'aria-controls': panelId, id: 'jbfilterk-' + root.id });
      /* Im Ring-Finder gelten nur die Antworten: Suche und Filter würden dort nichts bewirken und fehlen deshalb. */
      var leiste = el('div', { class: 'jb-konf__toolbar' }, F.finder ? [] : [suche, filterKnopf]);
      function setzeF(k) { return function (v) { F[k] = v; F.sichtbar = cfg.proSeite; zeichnen(); }; }
      var kollWerte = [[-1, 'Alle']].concat(D.kollektionen.map(function (k, i) { return [i, k + ' (' + D.anzahl[i] + ')']; }));
      var farbWerte = [['', 'Alle'], ['g', 'Gelbgold', 'g'], ['w', 'Weißgold', 'w'], ['r', 'Rotgold', 'r'], ['bi', 'Zweifarbig', 'bi']];
      var panel = el('div', { class: 'jb-konf__filter', id: panelId, hidden: !filterOffen || !!F.finder, role: 'region', 'aria-label': 'Filter' });
      if (cfg.preise) {
        panel.appendChild(el('p', { class: 'jb-konf__filter-titel', text: 'Preis je Ring' }));
        panel.appendChild(chipGruppe('Preis', [[0, 'Alle']].concat([750, 1000, 1250, 1500, 2000].map(function (v) { return [v, 'bis ' + euro(v)]; })), F.maxPreis, setzeF('maxPreis')));
      }
      panel.appendChild(el('p', { class: 'jb-konf__filter-titel', text: 'Farbe laut Abbildung' }));
      panel.appendChild(chipGruppe('Farbe', farbWerte, F.farbe, setzeF('farbe')));
      panel.appendChild(el('p', { class: 'jb-konf__filter-titel', text: 'Kollektion' }));
      panel.appendChild(chipGruppe('Kollektion', kollWerte, F.kollektion, setzeF('kollektion')));
      if (cfg.preise) {
        panel.appendChild(el('p', { class: 'jb-konf__filter-titel', text: 'Sortierung' }));
        panel.appendChild(chipGruppe('Sortierung', [['', 'Empfohlen'], ['auf', 'Preis aufsteigend'], ['ab', 'Preis absteigend']], F.sort, setzeF('sort')));
      }
      var zeigen = knopf('', 'jb-konf__btn jb-konf__filter-zeigen', function () { filterOffen = false; zeichnen(); var k = document.getElementById('jbfilterk-' + root.id); if (k) k.focus({ preventScroll: true }); });
      panel.appendChild(el('div', { class: 'jb-konf__aktionen' }, [zeigen,
        knopf('Filter löschen', 'jb-konf__link', function () { var l = F.liste; F = fLeer(); F.liste = l; zeichnen(); }, { hidden: !nf })]));
      panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); filterOffen = false; zeichnen(); var k = document.getElementById('jbfilterk-' + root.id); if (k) k.focus({ preventScroll: true }); } });
      /* Aktive Filter als kleine Pillen zum Entfernen */
      var pillen = el('div', { class: 'jb-konf__pillen', hidden: !nf || filterOffen || !!F.finder });
      function pille(text, k, leer) { pillen.appendChild(knopf(text, 'jb-konf__pille', function () { F[k] = leer; F.sichtbar = cfg.proSeite; zeichnen(); }, { 'aria-label': 'Filter ' + text + ' entfernen' })); }
      if (F.farbe) pille(farbWerte.filter(function (x) { return x[0] === F.farbe; })[0][1], 'farbe', '');
      if (F.kollektion >= 0) pille(D.kollektionen[F.kollektion], 'kollektion', -1);
      if (cfg.preise && F.maxPreis) pille('bis ' + euro(F.maxPreis), 'maxPreis', 0);
      if (cfg.preise && F.sort) pille(F.sort === 'auf' ? 'Preis aufsteigend' : 'Preis absteigend', 'sort', '');
      var anruf = anrufLink('anrufen', 'jb-konf__einstieg-tel');
      var einstieg = el('p', { class: 'jb-konf__einstieg' }, [el('span', { text: 'Unsicher? ' }),
        knopf('Ring-Finder starten', 'jb-konf__link jb-konf__einstieg-k', finderDialog), anruf ? el('span', { text: ' oder ' }) : null, anruf]);
      var merkHalter = el('div', { class: 'jb-konf__merk' });
      merkNeu = function () { merkGruppe(merkHalter); };
      var vglHalter = el('div', { class: 'jb-konf__vgl-leiste', role: 'region', 'aria-label': 'Vergleich' });
      vglNeu = function () { vglLeiste(vglHalter); };
      var finderInfo = el('div', { class: 'jb-konf__finder-info' });
      var anzahl = el('p', { class: 'jb-konf__anzahl', 'aria-live': 'polite' });
      var grid = el('ul', { class: 'jb-konf__grid' });
      var mehr = knopf('Weitere Modelle zeigen', 'jb-konf__btn jb-konf__btn--hell jb-konf__mehr', function () { F.sichtbar += cfg.proSeite; raster(true); });
      var laden = !Z.modell && !F.finder ? el('p', { class: 'jb-konf__laden' }, [knopf('Gespeicherte laden', 'jb-konf__link', speichernDialog)]) : null;
      function leerText() {
        if (F.liste === 'meine') return 'Noch keine Favoriten. Tippen Sie bei einem Modell auf das Herz. ';
        if (F.liste === 'match') return 'Noch kein gemeinsamer Favorit. Sehen Sie sich die Favoriten Ihres Partners an und setzen Sie Ihre Herzen. ';
        return 'Kein Modell gefunden. ';
      }
      function raster(anhaengen) {
        var res = F.finder ? finderErgebnis(F.finder) : null;
        var info = {};
        var t = res ? res.liste.map(function (x) { info[x.m.nr] = x; return x.m; }) : gefiltert();
        if (res && cfg.preise && F.sort) t = t.slice().sort(function (a, b) { var pa = info[a.nr].fp.p || 1e9, pb = info[b.nr].fp.p || 1e9; return F.sort === 'auf' ? pa - pb : pb - pa; });
        if (res) {
          finderInfo.textContent = '';
          finderInfo.appendChild(el('strong', { text: res.exakt ? (t.length === 1 ? '1 Modell passt' : t.length.toLocaleString('de-DE') + ' Modelle passen') + ' zu Ihren Antworten' : 'Kein Modell erfüllt alle Antworten. Diese kommen am nächsten:' }));
          finderInfo.appendChild(el('span', { text: finderText(F.finder) }));
          finderInfo.appendChild(el('div', { class: 'jb-konf__aktionen' }, [
            knopf('Antworten ändern', 'jb-konf__btn jb-konf__btn--hell', finderDialog),
            knopf('Finder beenden', 'jb-konf__link', function () { F = fLeer(); zeichnen(); })]));
        }
        anzahl.textContent = (t.length === 1 ? '1 Modell' : t.length.toLocaleString('de-DE') + ' Modelle') + (F.farbe || (F.finder && F.finder.farbe) ? ' · Farbe laut Abbildung' : '');
        zeigen.textContent = t.length ? (t.length === 1 ? '1 Modell anzeigen' : t.length.toLocaleString('de-DE') + ' Modelle anzeigen') : 'Kein Modell, Filter lockern';
        var von = anhaengen ? grid.children.length : 0;
        if (!anhaengen) grid.textContent = '';
        if (!t.length) grid.appendChild(el('li', { class: 'jb-konf__leer', style: 'grid-column:1/-1' }, [leerText(),
          F.liste === 'match' ? knopf('Favoriten Ihres Partners zeigen', 'jb-konf__link', function () { F.liste = 'partner'; zeichnen(); })
            : knopf('Filter zurücksetzen', 'jb-konf__link', function () { filterLeer(); zeichnen(); })]));
        t.slice(von, F.sichtbar).forEach(function (m) {
          var x = info[m.nr];
          var text = [el('strong', { text: 'Modell ' + m.m })];
          var ab = ep(abPreis(m)), jr = codeAn() ? ' je Ring mit Code' : ' je Ring';
          if (x && cfg.preise && x.fp.p) text.push(el('span', { class: 'jb-konf__preis', text: euro(x.fp.p) + jr }), el('span', { text: LEG[x.fp.l] + ', ' + STEIN[x.fp.s] }));
          else if (cfg.preise && ab) text.push(el('span', { class: 'jb-konf__preis', text: 'ab ' + euro(ab) + jr }));
          if (cfg.preise && !ab) text.push(el('span', { text: 'Preis auf Anfrage' }));
          text.push(el('span', { class: 'jb-konf__koll', text: kollName(m) }));
          if (x && !res.exakt && finderGrund(x)) text.push(el('span', { class: 'jb-konf__grund', text: finderGrund(x) }));
          if (partner.indexOf(m.m) >= 0) text.push(el('span', { class: 'jb-konf__tag' + (istFav(m) ? ' is-match' : ''), text: istFav(m) ? 'Euer Match' : 'Favorit Ihres Partners' }));
          var karte = knopf('', 'jb-konf__karte' + (Z.modell === m ? ' is-gewaehlt' : ''), function () { if (x) waehleFinder(m, x.fp); else waehle(m, 2); },
            { 'aria-pressed': String(Z.modell === m) });
          karte.appendChild(el('span', { class: 'jb-konf__bild' }, [bild(m, 400, '', true)]));
          karte.appendChild(el('span', { class: 'jb-konf__karte-text' }, text));
          karte.appendChild(el('span', { class: 'jb-konf__visually-hidden', text: ' ' + farbeText(m.c) + ' auswählen' }));
          var li = el('li', { class: 'jb-konf__karte-li' }, [karte]);
          kartenKnoepfe(li, m);
          grid.appendChild(li);
        });
        mehr.hidden = t.length <= F.sichtbar;
        if (anhaengen && grid.children[von]) grid.children[von].querySelector('button').focus({ preventScroll: true });
      }
      rasterNeu = function () { raster(); };
      merkNeu(); vglNeu();
      var kopf = el('div', { class: 'jb-konf__katalog-kopf' }, [einstieg, anzahl]);
      var teile = F.finder
        ? [finderInfo, vglHalter, anzahl, grid, mehr]
        : [leiste, panel, pillen, kopf, merkHalter, vglHalter, grid, mehr, laden];
      teile.forEach(function (x) { if (x) ziel.appendChild(x); });
      raster();
    }
    function waehleFinder(m, fp) {
      edelmetallBestaetigt = false; steinBestaetigt = false;
      aendern(function () {
        Z.modell = m;
        /* genau die Ausführung, deren Preis auf der Karte stand */
        if (fp.l >= 0) { Z.legierung = fp.l; Z.stein = fp.s; }
        passendeVariante(); Z.schritt = 2;
      });
      track('jb_konfigurator_modell', { jb_modell: m.m, jb_kollektion: kollName(m) });
      schrittFokus();
    }
    function waehle(m, naechster) {
      edelmetallBestaetigt = false; steinBestaetigt = false;
      aendern(function () { Z.modell = m; passendeVariante(); if (naechster) Z.schritt = naechster; });
      track('jb_konfigurator_modell', { jb_modell: m.m, jb_kollektion: kollName(m) });
      if (naechster) schrittFokus();
    }

    /* ---------- Vorschau (links) ---------- */
    /* Gravur auf der Ring-Innenseite: Blick schräg von oben in den Ring. Der hintere Innenwand-Streifen entsteht aus
       zwei senkrecht versetzten Ellipsen und ist überall gleich hoch, darin läuft der Text auf einem Bogen. */
    var METALL = {
      g: ['#8f6a1d', '#d4a843', '#f3d98b', '#fff4cf', 'rgba(52,34,8,.8)'],
      w: ['#76777d', '#bfc0c5', '#e4e5e8', '#ffffff', 'rgba(38,38,48,.82)'],
      r: ['#8d4f3b', '#d18c71', '#efb9a1', '#fde3d6', 'rgba(70,28,16,.8)']
    };
    var RING_BOGEN = 280, RING_GROSS = 22;
    function farbverlauf(id, farben, senkrecht) {
      var g = svgEl('linearGradient', senkrecht ? { id: id, x1: '0', y1: '0', x2: '0', y2: '1' } : { id: id, x1: '0', y1: '0', x2: '1', y2: '0' });
      farben.forEach(function (f, i) { g.appendChild(svgEl('stop', { offset: String(i / (farben.length - 1)), 'stop-color': f })); });
      return g;
    }
    function gravurBand(text, schrift, nr) {
      var metall = Z.farbwunsch !== 'bild' ? Z.farbwunsch : ((Z.modell.c || 'g').length > 1 ? 'bi' : (Z.modell.c || 'g'));
      var aussen = METALL[metall === 'bi' ? 'g' : metall], innen = METALL[metall === 'bi' ? 'w' : metall];
      var id = 'jbring' + (++ringZaehler) + '-' + root.id;
      var anzeige = text ? (schrift === 2 ? text.toUpperCase() : text) : 'Ihre Gravur';
      var defs = svgEl('defs', null, [
        farbverlauf(id + 'r', [aussen[0], aussen[2], aussen[3], aussen[1], aussen[0]]),
        farbverlauf(id + 's', [aussen[0], aussen[1], aussen[2], aussen[1], aussen[0]]),
        farbverlauf(id + 'w', [innen[0], innen[1], innen[2]], true),
        svgEl('clipPath', { id: id + 'c' }, [svgEl('ellipse', { cx: '160', cy: '60', rx: '128', ry: '38' })]),
        svgEl('mask', { id: id + 'm', maskUnits: 'userSpaceOnUse', x: '0', y: '0', width: '320', height: '150' }, [
          svgEl('rect', { x: '0', y: '0', width: '320', height: '150', fill: '#fff' }),
          svgEl('ellipse', { cx: '160', cy: '88', rx: '128', ry: '38', fill: '#000', 'clip-path': 'url(#' + id + 'c)' })]),
        svgEl('path', { id: id + 'p', d: 'M32,79 A128,38 0 0 1 288,79', fill: 'none' })
      ]);
      function textEl(farbe, dy) {
        var tp = svgEl('textPath', { startOffset: '50%', text: anzeige });
        tp.setAttribute('href', '#' + id + 'p');
        tp.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + id + 'p');
        return svgEl('text', { class: 'jb-konf__ring-text ' + SCHRIFTEN[schrift][1], fill: farbe, dy: dy, 'text-anchor': 'middle', style: 'font-size:' + RING_GROSS + 'px', 'data-zeichen': String(zeichen(anzeige).length) }, [tp]);
      }
      var ring = svgEl('svg', { class: 'jb-konf__ring', viewBox: '0 0 320 150', 'aria-hidden': 'true', focusable: 'false' }, [defs,
        svgEl('g', { mask: 'url(#' + id + 'm)' }, [
          svgEl('path', { d: 'M8,60 V88 A152,50 0 0 0 312,88 V60 Z', fill: 'url(#' + id + 's)' }),
          svgEl('path', { d: 'M8,60 a152,50 0 1,0 304,0 a152,50 0 1,0 -304,0 Z M32,60 a128,38 0 1,0 256,0 a128,38 0 1,0 -256,0 Z', 'fill-rule': 'evenodd', fill: 'url(#' + id + 'r)' }),
          svgEl('ellipse', { cx: '160', cy: '60', rx: '128', ry: '38', fill: 'url(#' + id + 'w)' })
        ]),
        svgEl('g', { class: text ? '' : 'is-leer' }, [textEl('rgba(255,255,255,.55)', '0.8'), textEl(innen[4], '0')])
      ]);
      return el('div', { class: 'jb-konf__band jb-konf__band--' + metall, role: 'img', 'aria-label': 'Gravurvorschau Ring ' + nr + ': ' + (text || 'keine Gravur') }, [
        ring,
        el('p', { class: 'jb-konf__band-zeile' }, [
          el('span', { class: 'jb-konf__band-nr', text: 'Ring ' + nr }),
          el('span', { class: 'jb-konf__band-text ' + SCHRIFTEN[schrift][1] + (text ? '' : ' is-leer'), text: text || 'Ihre Gravur' })])
      ]);
    }
    /* Langen Text auf den Bogen einpassen. Erst grob über die Zeichenzahl (falls ein Browser nicht messen kann), dann gemessen. */
    function ringeAnpassen(bereich) {
      var platz = RING_BOGEN * 0.74;
      Array.prototype.forEach.call((bereich || root).querySelectorAll('.jb-konf__ring'), function (svg) {
        var texte = svg.querySelectorAll('.jb-konf__ring-text');
        if (!texte.length) return;
        var n = Number(texte[0].getAttribute('data-zeichen')) || 1;
        var groesse = Math.min(RING_GROSS, platz / (n * 0.56));
        var setzen = function (g) { Array.prototype.forEach.call(texte, function (t) { t.style.fontSize = g.toFixed(2) + 'px'; }); };
        setzen(groesse);
        try {
          var laenge = texte[1].getComputedTextLength();
          if (laenge > 0 && isFinite(laenge)) setzen(Math.max(8, Math.min(RING_GROSS, groesse * platz / laenge)));
        } catch (e) { /* Schätzung bleibt */ }
      });
    }
    /* Gravurschriften laden erst bei Bedarf: danach neu einpassen */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ringeAnpassen(); });
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { ringeAnpassen(); });
    }
    function vorschau() {
      var m = Z.modell;
      var liste = gefiltert();
      var pos = liste.indexOf(m);
      if (pos < 0) { liste = D.modelle.filter(function (x) { return x.k === m.k; }); pos = liste.indexOf(m); }
      var vor = knopf('‹', 'jb-konf__blaettern jb-konf__blaettern--vor', function () { waehle(liste[(pos - 1 + liste.length) % liste.length]); }, { 'aria-label': 'Vorheriges Modell', id: 'jbvor-' + root.id });
      var nach = knopf('›', 'jb-konf__blaettern jb-konf__blaettern--nach', function () { waehle(liste[(pos + 1) % liste.length]); }, { 'aria-label': 'Nächstes Modell', id: 'jbnach-' + root.id });
      var bildKnopf = knopf('', 'jb-konf__vorschau-bild', zoomDialog, { 'aria-label': 'Bild vergrößern' });
      bildKnopf.appendChild(bild(m, 800, 'Trauring Modell ' + m.m + ' aus der Kollektion ' + kollName(m), false));
      bildKnopf.appendChild(el('span', { class: 'jb-konf__lupe', 'aria-hidden': 'true', text: '⤢' }));
      var chips = el('ul', { class: 'jb-konf__auswahl', 'aria-label': 'Ihre Auswahl', 'aria-live': 'polite' });
      ['Modell ' + m.m, farbeText(m.c), LEG[Z.legierung], STEIN[Z.stein]]
        .concat(Z.farbwunsch !== 'bild' ? ['Farbwunsch: ' + wahlText(FARBWUNSCH, Z.farbwunsch)] : [])
        .concat(Z.oberflaeche !== 'bild' ? [wahlText(OBERFL, Z.oberflaeche)] : [])
        .concat(Z.g1 || Z.g2 ? ['Größen ' + (Z.g1 ? String(Z.g1).replace('.', ',') : '?') + ' / ' + (Z.g2 ? String(Z.g2).replace('.', ',') : '?')] : [])
        .forEach(function (t) { chips.appendChild(el('li', { text: t })); });
      var fav = istFav(m), vgl = imVergleich(m);
      var herz = knopf(fav ? 'Gemerkt' : 'Merken', 'jb-konf__werkzeug jb-konf__merk-k' + (fav ? ' is-an' : ''), function () { favUmschalten(m); }, { 'aria-pressed': String(fav), id: 'jbvfav-' + root.id });
      herz.insertBefore(herzIcon(), herz.firstChild);
      var vk = knopf(vgl ? 'Im Vergleich' : 'Vergleichen', 'jb-konf__werkzeug jb-konf__merk-k' + (vgl ? ' is-an' : ''), function () { vglUmschalten(m); }, { 'aria-pressed': String(vgl), id: 'jbvvgl-' + root.id });
      vk.insertBefore(vglIcon(), vk.firstChild);
      var merkZeile = el('div', { class: 'jb-konf__vorschau-aktionen' }, [herz, vk]);
      if (vergleich.length > 1) merkZeile.appendChild(knopf('Vergleich ansehen (' + vergleich.length + ')', 'jb-konf__link', vergleichDialog, { id: 'jbvvgla-' + root.id }));
      if (partner.indexOf(m.m) >= 0) merkZeile.appendChild(el('span', { class: 'jb-konf__tag' + (fav ? ' is-match' : ''), text: fav ? 'Euer Match' : 'Favorit Ihres Partners' }));
      var box = el('div', { class: 'jb-konf__vorschau' }, [
        el('div', { class: 'jb-konf__vorschau-rahmen' }, [bildKnopf, vor, nach]),
        /* CILOR liefert ein Foto je Modell für alle Ausführungen: ehrlich sagen, was das Foto zeigt */
        el('p', { class: 'jb-konf__bildhinweis', text: 'Herstellerfoto. Ihre Ausführung: ' + LEG[Z.legierung] + ' · ' + STEIN[Z.stein] + '.' +
          (Z.stein === 0 ? ' Das Foto kann Steine zeigen, Ihre Ausführung ist ohne Steinbesatz.' : '') }),
        el('p', { class: 'jb-konf__vorschau-pos', text: 'Modell ' + (pos + 1) + ' von ' + liste.length + ' · ' + kollName(m) }),
        merkZeile,
        chips
      ]);
      if ((Z.gr1 || Z.gr2) && Z.schritt !== 4) box.appendChild(el('div', { class: 'jb-konf__baender' }, [gravurBand(Z.gr1, Z.f1, 1), gravurBand(Z.gr2, Z.f2, 2)]));
      var koll = D.modelle.filter(function (x) { return x.k === m.k; });
      var i = koll.indexOf(m);
      var nachbarn = koll.slice(Math.max(0, i - 3), i).concat(koll.slice(i + 1, i + 4));
      if (nachbarn.length < 6) nachbarn = koll.filter(function (x) { return x !== m; }).slice(0, 6);
      if (nachbarn.length) {
        var strip = el('ul', { class: 'jb-konf__aehnlich' });
        nachbarn.forEach(function (x) {
          var b = knopf('', 'jb-konf__aehnlich-k', function () { waehle(x); }, { 'aria-label': 'Modell ' + x.m + ' ansehen' });
          b.appendChild(bild(x, 200, '', true)); b.appendChild(el('span', { text: x.m }));
          strip.appendChild(el('li', null, [b]));
        });
        box.appendChild(el('p', { class: 'jb-konf__filter-titel', text: 'Auch aus der Kollektion ' + kollName(m) }));
        box.appendChild(strip);
      }
      return box;
    }

    /* ---------- Schritte 2–5 (rechts) ---------- */
    function optionen(titel, name, werte, aktiv, setzen, gesperrt, bestaetigen) {
      var fs = el('fieldset', { class: 'jb-konf__gruppe' }, [el('legend', { text: titel })]);
      var box = el('div', { class: 'jb-konf__optionen' });
      werte.forEach(function (w, i) {
        var id = name + '-' + i + '-' + root.id;
        var aus = gesperrt ? gesperrt(i) : false;
        var inp = el('input', { type: 'radio', name: name + root.id, id: id, value: String(i), checked: i === aktiv, disabled: aus });
        inp.addEventListener('click', function () { if (i === aktiv && bestaetigen) bestaetigen(); });
        inp.addEventListener('change', function () { aendern(function () { setzen(i); }); if (bestaetigen) bestaetigen(); });
        box.appendChild(el('label', { class: 'jb-konf__option' + (aus ? ' is-aus' : ''), for: id }, [inp,
          el('span', null, [w[0], el('small', { text: aus ? 'in dieser Kombination nicht verfügbar' : w[1] })])]));
      });
      fs.appendChild(box);
      return fs;
    }
    function wunschChips(titel, werte, aktiv, setzen) {
      return el('fieldset', { class: 'jb-konf__gruppe' }, [el('legend', { text: titel }),
        chipGruppe(titel, werte, aktiv, function (v) { aendern(function () { setzen(v); }); })]);
    }
    /* Eingeklappte, freiwillige Wünsche: nur sichtbar, wer sie sucht */
    function sonder(nr, gewaehlt, kinder) {
      var id = 'jbsonder-' + nr + '-' + root.id, offen = !!sonderOffen[nr];
      var inhalt = el('div', { id: id, class: 'jb-konf__sonder-inhalt', hidden: !offen }, kinder);
      var k = knopf('Sonderwünsche' + (gewaehlt ? ' (' + gewaehlt + ' gewählt)' : ' (optional)'), 'jb-konf__sonder-k', function () {
        sonderOffen[nr] = !sonderOffen[nr]; inhalt.hidden = !sonderOffen[nr]; k.setAttribute('aria-expanded', String(sonderOffen[nr]));
      }, { 'aria-expanded': String(offen), 'aria-controls': id, id: id + '-k' });
      return el('div', { class: 'jb-konf__sonder' }, [k, inhalt]);
    }
    /* ---------- Aktion: Banner, Knopf, Code-Feld ---------- */
    function codeGeaendert(fokusSel) {
      zeichnen();
      var f = fokusSel && root.querySelector(fokusSel); if (f) f.focus({ preventScroll: true });
    }
    function aktionKnopfZeile(quelle) {
      return knopf('Code ' + cfg.aktion.code + ' einlösen: −' + cfg.aktion.prozent + ' % je Ring', 'jb-konf__aktion-k', function () {
        if (codeEinloesen(cfg.aktion.code, quelle)) codeGeaendert('.jb-konf__aktion-weg');
      });
    }
    function aktionZeichnen() {
      aktionEl.textContent = '';
      if (!aktionLaeuft() || erfolgDa) { aktionEl.hidden = true; return; }
      aktionEl.hidden = false;
      var a = cfg.aktion;
      var kopf = el('p', { class: 'jb-konf__aktion-text' }, [el('span', { class: 'jb-konf__aktion-titel', text: a.titel }),
        el('span', { text: codeAn() ? 'Code ' + a.code + ' ist eingelöst. Alle Preise zeigen jetzt −' + a.prozent + ' % je Ring.'
          : a.prozent + ' % auf jeden Ring aus dem Konfigurator, bis ' + datumText(a.ende) + '.' })]);
      aktionEl.appendChild(kopf);
      if (codeAn()) aktionEl.appendChild(knopf('Code entfernen', 'jb-konf__link jb-konf__aktion-weg', function () {
        codeEingeloest = false; codeSpeichern(); track('jb_konfigurator_aktion', { jb_aktion: 'code_entfernt' }); codeGeaendert('.jb-konf__aktion-k');
      }));
      else aktionEl.appendChild(aktionKnopfZeile('banner'));
      if (a.bedingungen) aktionEl.appendChild(el('p', { class: 'jb-konf__aktion-klein', text: a.bedingungen }));
    }
    function codeFeld() {
      var id = 'jbcode-' + root.id;
      var wrap = el('div', { class: 'jb-konf__gruppe jb-konf__codefeld' });
      if (codeAn()) { wrap.appendChild(el('p', { class: 'jb-konf__codepreis', id: id + '-ok', tabindex: '-1', text: 'Aktionscode ' + cfg.aktion.code + ' ist eingelöst und steht in Ihrer Anfrage.' })); return wrap; }
      var inp = el('input', { type: 'text', id: id, autocomplete: 'off', autocapitalize: 'characters', spellcheck: 'false', maxlength: '30', placeholder: 'z. B. ' + cfg.aktion.code });
      var fehler = el('p', { class: 'jb-konf__hinweis jb-konf__codefehler', role: 'status', hidden: true });
      function los() {
        if (codeEinloesen(inp.value, 'feld')) { codeGeaendert('#' + id + '-ok'); return; }
        fehler.textContent = inp.value.trim() ? 'Dieser Code ist ungültig oder abgelaufen.' : 'Bitte geben Sie Ihren Code ein.'; fehler.hidden = false; inp.focus();
      }
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); los(); } });
      wrap.appendChild(el('label', { for: id, class: 'jb-konf__label', text: 'Aktionscode (optional)' }));
      wrap.appendChild(el('div', { class: 'jb-konf__codezeile' }, [inp, knopf('Einlösen', 'jb-konf__btn jb-konf__btn--zweit', los)]));
      wrap.appendChild(fehler);
      return wrap;
    }
    function preisBox() {
      var p = preis(Z.modell, Z.legierung, Z.stein);
      var box = el('div', { class: 'jb-konf__preisbox', 'aria-live': 'polite' });
      if (cfg.preise && p) {
        box.appendChild(el('small', { class: 'jb-konf__preis-label', text: 'Preis je Ring' })); box.appendChild(el('b', { text: euro(p) }));
        if (codeAn()) box.appendChild(el('p', { class: 'jb-konf__codepreis' }, [el('span', { text: 'Mit Code ' + cfg.aktion.code + ' (−' + cfg.aktion.prozent + ' %): ' }), el('strong', { text: euro(mitCode(p)) })]));
        else if (aktionLaeuft()) box.appendChild(aktionKnopfZeile('preisbox'));
        if (paarAn()) box.appendChild(el('p', { class: 'jb-konf__paarpreis', text: 'Paar (2 Ringe): ' + euro(2 * ep(p)) + ' · rechnerisch 2 × Preis je Ring' + (codeAn() ? ' mit Code' : '') }));
        box.appendChild(el('p', { class: 'jb-konf__hinweis', text: cfg.preisHinweis }));
      }
      else box.appendChild(el('p', { style: 'margin:0', text: 'Preis und Verfügbarkeit nennen wir Ihnen persönlich, abgestimmt auf Ihre Auswahl.' }));
      if (cfg.lieferzeit) box.appendChild(el('p', { class: 'jb-konf__liefer', text: cfg.lieferzeit }));
      return box;
    }
    function schritt2(ziel) {
      var m = Z.modell;
      /* In der Kachel nur Name und Preis, die Erklärung steht einmal ruhig darunter */
      var legW = LEG.map(function (t, i) { var p = ep(preis(m, i, Z.stein)); return [t, cfg.preise && p ? euro(p) : LEG_HINT[i]]; });
      var steinW = STEIN.map(function (t, i) { var p = ep(preis(m, Z.legierung, i)); return [t, cfg.preise && p ? euro(p) : STEIN_HINT[i]]; });
      ziel.appendChild(optionen('Legierung', 'jbleg', legW, Z.legierung, function (i) { Z.legierung = i; }, function (i) { return !verfuegbar(m, i, Z.stein); }, function () { auswahlBestaetigen('legierung'); }));
      if (cfg.preise) ziel.lastChild.appendChild(el('p', { class: 'jb-konf__hinweis', text: 'Die Zahl nennt den Goldanteil: 585 = 58,5 % Gold.' }));
      ziel.appendChild(optionen('Steinbesatz (wie abgebildet)', 'jbstein', steinW, Z.stein, function (i) { Z.stein = i; }, function (i) { return !verfuegbar(m, Z.legierung, i); }, function () { auswahlBestaetigen('stein'); }));
      if (cfg.preise) ziel.lastChild.appendChild(el('p', { class: 'jb-konf__hinweis', text: 'Zirkonia: funkelnder Schmuckstein · Brillant: echter Diamant.' }));
      ziel.appendChild(el('div', { class: 'jb-konf__aktionen jb-konf__weiter-im-panel' }, [
        knopf('Weiter zu den Ringgrößen', 'jb-konf__btn', function () { schritt(3); })]));
      ziel.appendChild(preisBox());
      if (m.p && m.p.some(function (p) { return !p; })) {
        var varianten = el('select', { id: 'jbvarianten-' + root.id });
        m.p.forEach(function (p, i) { if (p) varianten.appendChild(el('option', { value: String(i), text: LEG[Math.floor(i / 3)] + ' · ' + STEIN[i % 3] + (cfg.preise ? ' · ' + euro(ep(preis(m, Math.floor(i / 3), i % 3))) : ''), selected: i === Z.legierung * 3 + Z.stein })); });
        varianten.addEventListener('change', function () { var i = Number(varianten.value); aendern(function () { Z.legierung = Math.floor(i / 3); Z.stein = i % 3; }); });
        ziel.appendChild(el('div', { class: 'jb-konf__gruppe' }, [el('label', { for: varianten.id, class: 'jb-konf__label', text: 'Verfügbare Kombination wählen' }), varianten]));
      }
      ziel.appendChild(sonder(2, (Z.farbwunsch !== 'bild' ? 1 : 0) + (Z.oberflaeche !== 'bild' ? 1 : 0), [
        el('p', { class: 'jb-konf__hinweis jb-konf__hinweis--oben', text: 'Abgebildet: ' + farbeText(m.c) + '. Andere Farben und Oberflächen prüfen wir für Sie mit dem Hersteller.' }),
        wunschChips('Farbwunsch', FARBWUNSCH.map(function (x) { return [x[0], x[1], x[0] !== 'bild' ? x[0] : null]; }), Z.farbwunsch, function (v) { Z.farbwunsch = v; }),
        wunschChips('Oberfläche', OBERFL, Z.oberflaeche, function (v) { Z.oberflaeche = v; })]));
    }
    function groesseSelect(nr) {
      var key = 'g' + nr, id = 'jbg' + nr + '-' + root.id;
      var sel = el('select', { id: id });
      sel.appendChild(el('option', { value: '0', text: 'Weiß ich noch nicht' }));
      GROESSEN.forEach(function (g) { sel.appendChild(el('option', { value: String(g), text: 'Größe ' + groesseText(g), selected: Z[key] === g })); });
      sel.addEventListener('change', function () { var v = parseFloat(sel.value); aendern(function () { Z[key] = v; }); });
      return el('div', null, [el('label', { class: 'jb-konf__label', for: id, text: 'Ring ' + nr }), sel]);
    }
    function schritt3(ziel) {
      ziel.appendChild(el('p', { class: 'jb-konf__hinweis jb-konf__hinweis--oben', text: 'Größe unbekannt? Einfach offen lassen und trotzdem anfragen. Wir messen gern im Laden.' }));
      ziel.appendChild(el('fieldset', { class: 'jb-konf__gruppe' }, [el('legend', { text: 'Ringgröße' }),
        el('div', { class: 'jb-konf__zwei' }, [groesseSelect(1), groesseSelect(2)]),
        el('div', { class: 'jb-konf__aktionen' }, [knopf('Größe ermitteln', 'jb-konf__btn jb-konf__btn--hell', groesseDialog)])]));
      ziel.appendChild(el('div', { class: 'jb-konf__aktionen jb-konf__weiter-im-panel' }, [
        knopf('Weiter zur Gravur', 'jb-konf__btn', function () { schritt(4); })]));
      ziel.appendChild(sonder(3, Z.breite !== 'bild' ? 1 : 0, [
        el('p', { class: 'jb-konf__hinweis jb-konf__hinweis--oben', text: 'Form und Breite entsprechen dem abgebildeten Modell. Einen Breitenwunsch klären wir mit dem Hersteller.' }),
        wunschChips('Ringbreite', BREITE, Z.breite, function (v) { Z.breite = v; })]));
    }
    function schritt4(ziel) {
      var tabs = el('div', { class: 'jb-konf__tabs', role: 'tablist', 'aria-label': 'Gravur für' });
      var panelId = 'jbgravur-panel-' + root.id;
      [[1, 'Ring 1'], [2, 'Ring 2'], [3, 'Beide gleich']].forEach(function (t) {
        tabs.appendChild(knopf(t[1], 'jb-konf__tab', function () {
          if (t[0] === 3 && Z.gravurTab !== 3) { merkenVerlauf(); Z.gr2 = Z.gr1; Z.f2 = Z.f1; }
          Z.gravurTab = t[0]; urlSetzen(); zeichnen();
          document.getElementById('jbtab' + t[0] + '-' + root.id).focus({ preventScroll: true });
        }, { role: 'tab', 'aria-selected': String(Z.gravurTab === t[0]), tabindex: Z.gravurTab === t[0] ? '0' : '-1', 'aria-controls': panelId, id: 'jbtab' + t[0] + '-' + root.id }));
      });
      tabs.addEventListener('keydown', function (e) {
        var n = Z.gravurTab;
        if (e.key === 'ArrowRight') n = n % 3 + 1;
        else if (e.key === 'ArrowLeft') n = (n + 1) % 3 + 1;
        else if (e.key === 'Home') n = 1;
        else if (e.key === 'End') n = 3;
        else return;
        e.preventDefault(); tabs.children[n - 1].click();
      });
      ziel.appendChild(tabs);
      var panel = el('div', { role: 'tabpanel', id: panelId, 'aria-labelledby': 'jbtab' + Z.gravurTab + '-' + root.id });
      ziel.appendChild(panel); ziel = panel;
      var nr = Z.gravurTab === 2 ? 2 : 1;
      var gKey = 'gr' + nr, fKey = 'f' + nr;
      var id = 'jbgr-' + root.id;
      var feld = el('input', { type: 'text', id: id, value: Z[gKey], placeholder: 'z. B. Anna 12.06.2027', class: SCHRIFTEN[Z[fKey]][1] + ' jb-konf__gravurfeld', autocomplete: 'off', spellcheck: 'false', autocapitalize: 'off', 'aria-describedby': id + '-zaehler' });
      var zaehler = el('span', { id: id + '-zaehler', class: 'jb-konf__zaehler', 'aria-live': 'polite', text: 'noch ' + (MAX_GRAVUR - zeichen(Z[gKey]).length) + ' Zeichen' });
      var tipptGerade = false;
      function setzeText(v) {
        v = gravurText(v);
        if (!tipptGerade) { merkenVerlauf(); tipptGerade = true; }
        clearTimeout(tippTimer); tippTimer = setTimeout(function () { tipptGerade = false; navZeichnen(); }, 700);
        Z[gKey] = v; if (Z.gravurTab === 3) Z.gr2 = v;
        zaehler.textContent = 'noch ' + (MAX_GRAVUR - zeichen(v).length) + ' Zeichen';
        var baender = root.querySelector('.jb-konf__baender');
        if (baender) { baender.textContent = ''; baender.appendChild(gravurBand(Z.gr1, Z.f1, 1)); baender.appendChild(gravurBand(Z.gr2, Z.f2, 2)); ringeAnpassen(baender); }
        urlSetzen(); balkenZeichnen();
      }
      feld.addEventListener('input', function (e) { if (e.isComposing) return; feld.value = gravurText(feld.value); setzeText(feld.value); });
      feld.addEventListener('compositionend', function () { feld.value = gravurText(feld.value); setzeText(feld.value); });
      var symbole = el('div', { class: 'jb-konf__chips', role: 'group', 'aria-label': 'Symbol einfügen' });
      SYMBOLE.forEach(function (s) {
        symbole.appendChild(knopf(s, 'jb-konf__chip jb-konf__chip--symbol', function () {
          var a = feld.selectionStart != null ? feld.selectionStart : feld.value.length;
          var ende = feld.selectionEnd != null ? feld.selectionEnd : a;
          var neu = feld.value.slice(0, a) + s + feld.value.slice(ende);
          if (zeichen(neu).length > MAX_GRAVUR) return;
          feld.value = neu;
          setzeText(feld.value); feld.focus(); feld.setSelectionRange(a + s.length, a + s.length);
        }, { 'aria-label': 'Symbol ' + s + ' einfügen' }));
      });
      ziel.appendChild(el('label', { class: 'jb-konf__label', for: id, text: Z.gravurTab === 3 ? 'Gravurtext für beide Ringe' : 'Gravurtext Ring ' + nr }));
      ziel.appendChild(el('div', { class: 'jb-konf__gravurzeile' }, [feld, zaehler]));
      ziel.appendChild(el('p', { class: 'jb-konf__filter-titel', text: 'Symbol einfügen' }));
      ziel.appendChild(symbole);
      ziel.appendChild(wunschChips('Schrift', SCHRIFTEN.map(function (s, i) { return [i, s[0]]; }), Z[fKey], function (v) { Z[fKey] = v; if (Z.gravurTab === 3) { Z.f1 = v; Z.f2 = v; } }));
      ziel.appendChild(el('div', { class: 'jb-konf__baender' }, [gravurBand(Z.gr1, Z.f1, 1), gravurBand(Z.gr2, Z.f2, 2)]));
      if (cfg.gravurarten.length) {
        ziel.appendChild(wunschChips('Gravurart', [[0, 'Noch offen']].concat(cfg.gravurarten.map(function (g, i) { return [i + 1, g.name]; })), Z.gravurArt, function (v) { Z.gravurArt = v; }));
        var ga = cfg.gravurarten[Z.gravurArt - 1];
        if (ga && (ga.info || ga.preis)) ziel.appendChild(el('p', { class: 'jb-konf__hinweis', text: [ga.info, ga.preis].filter(Boolean).join(' · ') }));
      }
      ziel.appendChild(el('p', { class: 'jb-konf__hinweis', text: 'Schriftvorschau zur Orientierung. Zeichen, Schrift und Umsetzung Ihrer Gravur stimmen wir persönlich ab.' }));
      ziel.appendChild(el('div', { class: 'jb-konf__aktionen jb-konf__weiter-im-panel' }, [
        knopf('Weiter zur Anfrage', 'jb-konf__btn', function () { schritt(5); })]));
    }
    function schritt5(ziel) {
      ziel.appendChild(el('p', { class: 'jb-konf__hinweis jb-konf__hinweis--oben', text: 'Prüfen Sie Ihre Auswahl. Mit der Anfrage kaufen Sie noch nichts. Wir besprechen Verfügbarkeit, Wünsche und das Angebot für Ihr Ringpaar persönlich mit Ihnen.' }));
      ziel.appendChild(detailTabelle());
      if (aktionLaeuft()) ziel.appendChild(codeFeld());
      if (cfg.lieferzeit) ziel.appendChild(el('p', { class: 'jb-konf__liefer', text: cfg.lieferzeit }));
      ziel.appendChild(wunschChips('Ihr Anliegen', ANLIEGEN.map(function (t, i) { return [i, t]; }), Z.anliegen, function (v) { Z.anliegen = v; }));
      var vs = el('input', { type: 'checkbox', id: 'jbvs-' + root.id, checked: Z.vorsteck });
      vs.addEventListener('change', function () { aendern(function () { Z.vorsteck = vs.checked; }); });
      ziel.appendChild(el('label', { class: 'jb-konf__check', for: 'jbvs-' + root.id }, [vs, el('span', { text: 'Passenden Vorsteckring mit anfragen' })]));
      if (formWrap && !erfolgDa) { formWrap.hidden = false; ziel.appendChild(formWrap); formFelderSetzen(); }
    }

    /* ---------- Feste Leiste unten ---------- */
    var balken = el('div', { class: 'jb-konf__balken', hidden: true });
    root.appendChild(balken);
    function balkenZeichnen() {
      balken.textContent = '';
      if (!Z.modell || erfolgDa) { balken.hidden = true; return; }
      balken.hidden = false;
      var m = Z.modell, p = preis(m, Z.legierung, Z.stein);
      var info = el('div', { class: 'jb-konf__balken-info' }, [bild(m, 120, '', false),
        el('div', null, [el('strong', { text: 'Modell ' + m.m }), el('span', { text: LEG[Z.legierung] + ' · ' + STEIN[Z.stein] }),
          cfg.lieferzeit ? el('span', { class: 'jb-konf__balken-liefer', text: cfg.lieferzeit }) : null])]);
      var preisEl = el('div', { class: 'jb-konf__balken-preis' }, cfg.preise && p ? [el('small', { text: codeAn() ? 'Je Ring mit Code' : 'Preis je Ring inkl. MwSt.' }), el('b', { text: euro(ep(p)) }),
        codeAn() ? el('small', { class: 'jb-konf__balken-paar', text: 'ohne Code ' + euro(p) }) : null,
        paarAn() ? el('small', { class: 'jb-konf__balken-paar', text: 'Paar: ' + euro(2 * ep(p)) }) : null] : [el('small', { text: 'Preis' }), el('b', { text: 'auf Anfrage' })]);
      function zu(fn) { return function () { mehrOffen = false; menue.hidden = true; mehrK.setAttribute('aria-expanded', 'false'); fn(); }; }
      var menueId = 'jbmehr-' + root.id;
      var menue = el('div', { class: 'jb-konf__mehr-menue', id: menueId, hidden: !mehrOffen }, [
        anrufLink('Anrufen' + (cfg.telefonText ? ': ' + cfg.telefonText : ''), 'jb-konf__werkzeug jb-konf__werkzeug--tel'),
        knopf('Details', 'jb-konf__werkzeug', zu(detailsDialog)), knopf('Speichern', 'jb-konf__werkzeug', zu(speichernDialog)),
        knopf('Drucken', 'jb-konf__werkzeug', zu(drucken)), knopf('Teilen', 'jb-konf__werkzeug', zu(teilen))
      ]);
      var mehrK = knopf('Mehr', 'jb-konf__mehr-k', function () { mehrOffen = !mehrOffen; menue.hidden = !mehrOffen; mehrK.setAttribute('aria-expanded', String(mehrOffen)); if (mehrOffen) menue.querySelector('button').focus(); },
        { 'aria-expanded': String(mehrOffen), 'aria-controls': menueId, 'aria-label': 'Mehr: Details, Speichern, Drucken, Teilen', id: 'jbmehrk-' + root.id });
      menue.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); mehrOffen = false; menue.hidden = true; mehrK.setAttribute('aria-expanded', 'false'); mehrK.focus(); } });
      var tools = el('div', { class: 'jb-konf__balken-tools' }, [mehrK, menue]);
      var weiter = Z.schritt < 5 ? knopf(Z.schritt === 4 ? 'Weiter zur Anfrage' : 'Weiter', 'jb-konf__btn', function () { schritt(Z.schritt + 1); })
        : knopf('Zum Formular', 'jb-konf__btn', function () { var n = formular && formular.querySelector('input[name="contact[name]"]'); if (n) { n.scrollIntoView({ block: 'center' }); n.focus(); } });
      balken.appendChild(el('div', { class: 'jb-konf__balken-innen' }, [info, preisEl, tools, weiter]));
    }
    /* Menü „Mehr“ schließt bei Klick daneben */
    document.addEventListener('click', function (e) {
      if (!mehrOffen || balken.contains(e.target)) return;
      mehrOffen = false; var mm = balken.querySelector('.jb-konf__mehr-menue'), mk = balken.querySelector('.jb-konf__mehr-k');
      if (mm) mm.hidden = true; if (mk) mk.setAttribute('aria-expanded', 'false');
    });
    function abstandMessen() { root.style.setProperty('--jb-konf-bottom', (balken.hidden ? 0 : balken.getBoundingClientRect().height) + 'px'); }
    if (window.ResizeObserver) new ResizeObserver(abstandMessen).observe(balken);

    /* ---------- Formular ---------- */
    function formFelderSetzen() {
      if (!formular || !Z.modell) return;
      var m = Z.modell, p = preis(m, Z.legierung, Z.stein);
      var werte = {
        Modell: m.m, Kollektion: kollName(m), Farbe_laut_Abbildung: farbeText(m.c),
        Farbwunsch: wahlText(FARBWUNSCH, Z.farbwunsch), Oberflaeche: wahlText(OBERFL, Z.oberflaeche), Breite: wahlText(BREITE, Z.breite),
        Legierung: LEG[Z.legierung], Steinbesatz: STEIN[Z.stein],
        Ringgroesse_1: Z.g1 ? groesseText(Z.g1) : 'noch offen', Ringgroesse_2: Z.g2 ? groesseText(Z.g2) : 'noch offen',
        Gravur_1: Z.gr1 || '-', Gravur_2: Z.gr2 || '-', Schrift_1: Z.gr1 ? SCHRIFTEN[Z.f1][0] : '-', Schrift_2: Z.gr2 ? SCHRIFTEN[Z.f2][0] : '-',
        Vorsteckring: Z.vorsteck ? 'ja, mit anfragen' : 'nein', Anliegen_Art: ANLIEGEN[Z.anliegen],
        Preis_je_Ring: cfg.preise && p ? euro(p) + ' inkl. MwSt. (angezeigt)' : 'nicht angezeigt', Konfiguration_Link: linkBauen(),
        Preis_Paar: paarAn() && p ? euro(2 * ep(p)) + ' inkl. MwSt. (rechnerisch 2 × Preis je Ring' + (codeAn() ? ' mit Code' : '') + ', angezeigt)' : 'nicht angezeigt',
        Gravurart: gravurArtText(),
        Aktionscode: codeAn() ? cfg.aktion.code + ' (' + cfg.aktion.titel + ', −' + cfg.aktion.prozent + ' % je Ring, online eingelöst)' : 'nicht eingelöst',
        Preis_mit_Code: codeAn() && p ? euro(mitCode(p)) + ' je Ring inkl. MwSt. (angezeigt)' : '-'
      };
      Object.keys(werte).forEach(function (k) {
        var f = formular.querySelector('[data-jb-feld="' + k + '"]');
        if (f) { f.value = werte[k]; f.disabled = false; }
      });
    }
    if (formular) {
      var waKnopf = formular.querySelector('[data-jb-wa-kind="trauring"]');
      if (waKnopf) waKnopf.addEventListener('click', function (e) {
        if (!Z.modell) { e.stopPropagation(); schritt(1); return; }
        formFelderSetzen();
      });
      /* Vor jedem anderen Lauscher (z. B. Meldungs-Snippet): Felder auf den aktuellen Stand, auch wenn die Aktion inzwischen abgelaufen ist */
      window.addEventListener('submit', function (e) { if (e.target === formular && Z.modell) formFelderSetzen(); }, true);
      formular.querySelectorAll('[required]').forEach(function (f) {
        function validieren() { f.setCustomValidity(f.value && !f.value.trim() ? 'Bitte füllen Sie dieses Feld aus.' : ''); }
        f.addEventListener('input', validieren); f.addEventListener('change', validieren);
      });
      formular.addEventListener('submit', function (e) {
        if (!Z.modell) { e.preventDefault(); schritt(1); return; }
        formFelderSetzen();
        formular.querySelectorAll('[required]').forEach(function (f) { f.setCustomValidity(!f.value.trim() ? 'Bitte füllen Sie dieses Feld aus.' : ''); });
        if (!formular.checkValidity()) { e.preventDefault(); formular.reportValidity(); return; }
        /* Shopify prüft vor dem Absenden unsichtbar auf Spam (hCaptcha). Das kann dauern: sichtbar machen, dass etwas passiert. */
        sendenAnzeigen();
        if (!absendenGemeldet) { absendenGemeldet = true; track('jb_konfigurator_absenden', { jb_modell: Z.modell.m }); }
        try { sessionStorage.setItem('jb_konf_gesendet', '1'); } catch (x) { /* privat */ }
      });
      formular.addEventListener('input', sendenZuruecksetzen);
      window.addEventListener('pageshow', sendenZuruecksetzen);
    }
    var absendenGemeldet = false, sendeTimer;
    var sendeKnopf = formular && formular.querySelector('button[type=submit]');
    var sendeText = sendeKnopf ? sendeKnopf.textContent : '';
    var sendeHinweis = null;
    if (sendeKnopf) {
      var tel = anrufLink(cfg.telefonText || 'anrufen', '');
      sendeHinweis = el('p', { class: 'jb-konf__hinweis jb-konf__sende-hinweis', role: 'status', hidden: true },
        ['Dauert es zu lange? Bitte prüfen Sie, ob ein Sicherheitsfenster offen ist', tel ? ', oder rufen Sie uns an: ' : '.', tel]);
      sendeKnopf.parentNode.appendChild(sendeHinweis);
    }
    function sendenAnzeigen() {
      if (!sendeKnopf) return;
      sendeKnopf.textContent = 'Wird gesendet …'; sendeKnopf.setAttribute('aria-busy', 'true'); sendeKnopf.classList.add('is-sendet');
      clearTimeout(sendeTimer); sendeTimer = setTimeout(function () { if (sendeHinweis) sendeHinweis.hidden = false; }, 8000);
    }
    function sendenZuruecksetzen() {
      if (!sendeKnopf || !sendeKnopf.classList.contains('is-sendet')) return;
      clearTimeout(sendeTimer); sendeKnopf.textContent = sendeText; sendeKnopf.removeAttribute('aria-busy'); sendeKnopf.classList.remove('is-sendet');
      if (sendeHinweis) sendeHinweis.hidden = true;
    }

    /* ---------- Gesamt zeichnen ---------- */
    function zeichnen() {
      clearTimeout(suchTimer); clearTimeout(tippTimer);
      var vorher = document.activeElement;
      var fokusId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : '';
      var fokusName = vorher && root.contains(vorher) && vorher.tagName === 'BUTTON' ? vorher.getAttribute('aria-label') || vorher.textContent : '';
      if (formWrap && !erfolgDa && formWrap.parentNode !== formParkplatz) { formWrap.hidden = true; formParkplatz.appendChild(formWrap); }
      navZeichnen();
      app.textContent = '';
      if (Z.schritt === 1 || !Z.modell) {
        var voll = el('div', { class: 'jb-konf__panel jb-konf__panel--voll' }, [kopfZeile(1)]);
        app.appendChild(voll);
        schritt1(voll);
      } else {
        var rechts = el('div', { class: 'jb-konf__panel' }, [kopfZeile(Z.schritt)]);
        [null, null, schritt2, schritt3, schritt4, schritt5][Z.schritt](rechts);
        app.appendChild(el('div', { class: 'jb-konf__detail' }, [vorschau(), rechts]));
      }
      aktionZeichnen();
      balkenZeichnen();
      abstandMessen();
      ringeAnpassen(app);
      if (fokusId) { var f = document.getElementById(fokusId); if (f && f.focus) f.focus({ preventScroll: true }); }
      else if (fokusName) {
        var f2 = Array.prototype.find.call(root.querySelectorAll('button'), function (b) { return !b.disabled && (b.getAttribute('aria-label') || b.textContent) === fokusName; });
        if (f2) f2.focus({ preventScroll: true });
      }
    }

    /* Schrittleiste und Vorschau docken unter einer festen Theme-Kopfzeile an, statt darunter zu verschwinden */
    var kopfKandidaten = null;
    function kandidatenSuchen() {
      kopfKandidaten = [];
      document.querySelectorAll('header, sticky-header, [role="banner"], .shopify-section-header, [id*="header"], [class*="sticky-header"], [class*="Header"]').forEach(function (n) {
        if (root.contains(n) || n.closest('.jb-konf__dialog-hg')) return;
        var p = getComputedStyle(n).position;
        /* auch Kopfzeilen, die erst beim Scrollen fest werden */
        if (p === 'fixed' || p === 'sticky' || n.matches('header, sticky-header, [class*="header"]')) kopfKandidaten.push(n);
      });
    }
    function kopfzeileMessen() {
      if (!kopfKandidaten) kandidatenSuchen();
      var unten = 0;
      kopfKandidaten.forEach(function (n) {
        var p = getComputedStyle(n).position;
        if (p !== 'fixed' && p !== 'sticky') return;
        var r = n.getBoundingClientRect();
        if (r.top <= 2 && r.bottom > 0 && r.bottom < 200 && r.width > window.innerWidth * 0.5) unten = Math.max(unten, r.bottom);
      });
      root.style.setProperty('--jb-konf-top', Math.round(unten) + 'px');
    }
    var messTimer;
    window.addEventListener('scroll', function () { clearTimeout(messTimer); messTimer = setTimeout(kopfzeileMessen, 80); }, { passive: true });
    window.addEventListener('resize', function () { kopfKandidaten = null; kopfzeileMessen(); });
    setTimeout(function () { kopfKandidaten = null; kopfzeileMessen(); }, 1500);

    root.querySelectorAll('[data-jb-contact]').forEach(function (a) {
      a.addEventListener('click', function () { track('jb_trauring_kontakt', { jb_kontaktweg: a.getAttribute('data-jb-contact') }); });
    });

    if (erfolgDa) {
      var offen = false;
      try { offen = sessionStorage.getItem('jb_konf_gesendet') === '1'; sessionStorage.removeItem('jb_konf_gesendet'); } catch (x) { /* privat */ }
      if (offen) track('jb_konfigurator_anfrage', {});
      formWrap.hidden = false;
      app.parentNode.insertBefore(formWrap, app);
      erfolg.scrollIntoView({ block: 'center' });
    }

    function datenLaden() {
    app.setAttribute('aria-busy', 'true');
    fetch(cfg.quelle, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (daten) {
      if (!daten || !Array.isArray(daten.modelle) || !daten.modelle.length || !Array.isArray(daten.kollektionen) ||
        daten.modelle.some(function (m) { return !m || typeof m.m !== 'string' || typeof m.b !== 'string' || typeof m.f !== 'string' || !Number.isInteger(m.k) || !daten.kollektionen[m.k] || (m.p !== null && (!Array.isArray(m.p) || m.p.length !== 9 || m.p.some(function (p) { return typeof p !== 'number' || !Number.isFinite(p) || p < 0; }))); })) throw new Error('Modelldaten ungültig');
      D = daten;
      D.anzahl = D.kollektionen.map(function (_, i) { return D.modelle.filter(function (m) { return m.k === i; }).length; });
      D.modelle.forEach(function (m, i) { m.nr = i; });
      var u = null;
      try { u = new URL(window.location.href); } catch (e) { /* egal */ }
      merkLaden();
      /* Aktionscode aus Link (?code=…, z. B. aus Anzeigen) oder aus dieser Sitzung */
      var codeAusLink = u && u.searchParams.get('code'), codeGemerkt = '';
      try { codeGemerkt = sessionStorage.getItem('jb_konf_code') || ''; } catch (e) { /* privat */ }
      if (codeAusLink) { if (!codeEinloesen(codeAusLink, 'link') && aktionLaeuft()) hinweis('Dieser Aktionscode ist ungültig oder abgelaufen.'); }
      else if (codeGemerkt) codeEinloesen(codeGemerkt, 'sitzung');
      var favsOffen = u && u.searchParams.has('favs') ? favsAusLink(u.searchParams.get('favs')) : false;
      var geladen = false, stand = null;
      try { stand = JSON.parse(sessionStorage.getItem('jb_konf_stand') || 'null'); } catch (e) { stand = null; }
      if (!stand || typeof stand.code !== 'string') stand = null;
      function grundCode(code) { var t = code.split('.').slice(0, 4); if (t[1]) t[1] = t[1].padEnd(11, '0'); return t.join('.'); }
      var urlKonf = u && u.searchParams.get('konf');
      if (urlKonf) {
        geladen = codeLaden(urlKonf);
        if (geladen && !gravurAusHash(location.hash) && stand && stand.code && grundCode(stand.code) === grundCode(codeBauen(true))) {
          codeLaden(stand.code); /* gleiche Auswahl wie vor dem Neuladen: Gravur zurückholen */
        }
      } else if (stand && stand.code && !(u && u.searchParams.get('modell'))) {
        geladen = codeLaden(stand.code);
      }
      if (!geladen && u && u.searchParams.get('modell')) {
        var m = modellZuNr(u.searchParams.get('modell'));
        if (m) { Z.modell = m; passendeVariante(); geladen = true; }
      }
      if (geladen) {
        Z.schritt = stand && grundCode(stand.code) === grundCode(codeBauen(true)) && Number.isInteger(stand.schritt) && stand.schritt >= 1 && stand.schritt <= 5 ? stand.schritt : 2;
      } else if (u && (urlKonf || u.searchParams.has('modell'))) hinweis('Diese Konfiguration konnte nicht geöffnet werden. Bitte wählen Sie Ihr Modell neu oder prüfen Sie den gespeicherten Code.');
      /* Wer einen Favoriten-Link öffnet, sieht zuerst die Ringe des Partners. Eine laufende eigene Auswahl bleibt erhalten. */
      if (favsOffen) Z.schritt = 1;
      var formFehler = formular && formular.querySelector('.jb-konf__fehler');
      if (formFehler && Z.modell) Z.schritt = 5;
      urlSetzen();
      app.setAttribute('aria-busy', 'false');
      zeichnen();
      if (erfolgDa) { erfolg.focus(); erfolg.scrollIntoView({ block: 'center' }); }
      else if (formFehler) {
        if (!Z.modell) { formWrap.hidden = false; app.appendChild(formWrap); }
        formFehler.setAttribute('tabindex', '-1'); formFehler.focus(); formFehler.scrollIntoView({ block: 'center' });
      }
    }).catch(function () {
      app.setAttribute('aria-busy', 'false');
      app.textContent = '';
      app.appendChild(el('p', { class: 'jb-konf__leer', text: 'Die Modellauswahl konnte gerade nicht geladen werden. Rufen Sie uns gern an, wir beraten Sie persönlich.' }));
      app.appendChild(knopf('Erneut laden', 'jb-konf__btn', datenLaden));
      var telefon = root.querySelector('[data-jb-contact="phone"]');
      if (telefon) app.appendChild(el('p', { class: 'jb-konf__kontakt' }, [el('a', { href: telefon.getAttribute('href'), text: 'Anrufen: ' + cfg.telefonText })]));
    });
    }
    datenLaden();
  }

  function init() { document.querySelectorAll('[data-jb-konf]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
